import { IsoCountryCode } from 'utils/form/constants';
import { Platform } from 'utils/environment/types';
import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
}

/** A First Data or Adyen account (payment method) will have either credit or prepaid but not both */
export interface IAccount {
  readonly __typename?: 'Account';
  /** Common PSP payment method identifier and Adyen account identifier. */
  readonly accountIdentifier?: Maybe<Scalars['String']>;
  /** Used for making cc direct payments with chase (TH) */
  readonly chaseProfileId?: Maybe<Scalars['String']>;
  readonly credit?: Maybe<ICreditCard>;
  /** First Data account ID */
  readonly fdAccountId?: Maybe<Scalars['String']>;
  /** Orbital account stored payment method id */
  readonly orbitalIdentifier?: Maybe<Scalars['String']>;
  readonly paypal?: Maybe<Scalars['Boolean']>;
  readonly paypalIdentifier?: Maybe<Scalars['String']>;
  readonly prepaid?: Maybe<IGiftCard>;
}

export interface IAccountListResponse {
  readonly __typename?: 'AccountListResponse';
  readonly accounts?: Maybe<ReadonlyArray<Maybe<IAccount>>>;
  readonly count: Scalars['Int'];
  readonly defaultAccount?: Maybe<IAccount>;
  readonly paymentProcessor?: Maybe<PaymentProcessor>;
}

/** Add a First Data account (payment method) for the current user */
export interface IAddAccountInput {
  /** billingAddress associated to card */
  readonly billingAddress?: InputMaybe<IBillingAddressInput>;
  /** First 6 digits of credit card */
  readonly ccBin: Scalars['String'];
  /** cc token from tokenex required for chase direct pay enrollment */
  readonly ccToken?: InputMaybe<Scalars['String']>;
  /** cc security code */
  readonly cvv?: InputMaybe<Scalars['String']>;
  /** Access token which was used to request nonce */
  readonly fdAccessToken: Scalars['String'];
  /** Nonce provided by FD linking to the new payment method */
  readonly fdNonce: Scalars['String'];
  /** Name On Card */
  readonly fullName?: InputMaybe<Scalars['String']>;
  /** Make this new account the user's default account */
  readonly makeDefault?: InputMaybe<Scalars['Boolean']>;
  /** Session ID as set by the FE. This should be derived from mParticle. */
  readonly sessionId?: InputMaybe<Scalars['String']>;
  /** threeDSOptions to resume account creation */
  readonly threeDSOptions?: InputMaybe<IThreeDsOptions>;
}

/** Add payment method for the current user */
export interface IAddCreditAccountInput {
  /** billingAddress associated to card */
  readonly billingAddress: IBillingAddressInput;
  readonly firstDataInput?: InputMaybe<IAddAccountInput>;
  /** Name on credit card */
  readonly fullName: Scalars['String'];
  /** (TH only) Make this new account the user's default account */
  readonly makeDefault?: InputMaybe<Scalars['Boolean']>;
  readonly orbitalInput?: InputMaybe<IAddOrbitalAccountInput>;
}

/** Add a gift account (payment method) for the current user */
export interface IAddGiftAccountInput {
  /** Details from Apple Pay for funding. */
  readonly applePayDetails?: InputMaybe<IApplePay>;
  /**
   * Vaulted first data Account ID (credit) used to fund gift card.
   * Either this or applePayDetails is required.
   */
  readonly fdAccountId?: InputMaybe<Scalars['String']>;
  /** Amount to fund to gift card account in cents */
  readonly fundValue: Scalars['Int'];
  /** Details from Goole Pay for funding. */
  readonly googlePayDetails?: InputMaybe<IGooglePay>;
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   */
  readonly kountSessionId?: InputMaybe<Scalars['String']>;
  /**
   * Session ID as set by the FE.
   *
   * Note that the "sessionId" field is deprecated and will be ignored.
   */
  readonly sessionId?: InputMaybe<Scalars['String']>;
}

/** Add Orbital (payment method) for the current user */
export interface IAddOrbitalAccountInput {
  readonly bin: Scalars['String'];
  readonly cardBrand: Scalars['String'];
  readonly encryptedCardNum: Scalars['String'];
  readonly encryptedCvv: Scalars['String'];
  readonly expiryMonth: Scalars['String'];
  readonly expiryYear: Scalars['String'];
  readonly pieFormat: Scalars['String'];
  readonly pieIntegrityCheck: Scalars['String'];
  readonly pieKeyID: Scalars['String'];
  readonly pieMode: Scalars['String'];
  readonly piePhaseId: Scalars['String'];
  readonly pieSubscriberId: Scalars['String'];
}

export interface IAdyenEncryptedInfo {
  /** Encrypted credit card number */
  readonly encryptedCN: Scalars['String'];
  /** Encrypted credit card expiry month */
  readonly encryptedEM: Scalars['String'];
  /** Encrypted credit card expiry year */
  readonly encryptedEY: Scalars['String'];
  /** Encrypted credit card security code */
  readonly encryptedSC: Scalars['String'];
}

export interface IApiMetadata {
  readonly __typename?: 'ApiMetadata';
  /** Pong! Simple health check. */
  readonly ping: Scalars['String'];
}

/** Details from Apple Pay used for Apple Pay funding. */
export interface IApplePay {
  /** Data of the payment method used for Apple Pay. */
  readonly PaymentMethodData?: InputMaybe<IPaymentMethodData>;
  /** Application data as passed through from Apple Pay */
  readonly applicationData: Scalars['String'];
  readonly billingAddress: IBillingAddressInput;
  /** part of the billing address from apple pay */
  readonly country: CountryCode;
  readonly data: Scalars['String'];
  readonly decryptAlias: Scalars['String'];
  readonly ephemeralPublicKey: Scalars['String'];
  readonly formatted: Scalars['String'];
  /** bundle all apple pay details into an encrypted token. */
  readonly paymentData?: InputMaybe<Scalars['String']>;
  readonly primary: Scalars['Boolean'];
  readonly publicKeyHash: Scalars['String'];
  /** Signature as passed through from Apple Pay */
  readonly signature: Scalars['String'];
  readonly transactionId: Scalars['String'];
  /** type of the billing address set in apple pay e.g. work, home, etc */
  readonly type: Scalars['String'];
  readonly version: Scalars['String'];
}

export interface IAppliedOffer {
  readonly cartId?: InputMaybe<Scalars['ID']>;
  readonly id?: InputMaybe<Scalars['ID']>;
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: InputMaybe<Scalars['ID']>;
  readonly swap?: InputMaybe<ISwapInput>;
  readonly type?: InputMaybe<OfferType>;
}

export interface IAppliedReward {
  readonly cartId: Scalars['ID'];
  readonly rewardId: Scalars['ID'];
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: InputMaybe<Scalars['ID']>;
  readonly timesApplied: Scalars['Int'];
}

export interface IAttemptLoginOtpResponse {
  readonly __typename?: 'AttemptLoginOTPResponse';
  /** OTP information. Present if user found and signin with otp started */
  readonly otp?: Maybe<ICreateOtp>;
  /** Indicates if the user was found or not */
  readonly result: AttemptLoginOtpResult;
}

export enum AttemptLoginOtpResult {
  FOUND = 'FOUND',
  NOT_FOUND = 'NOT_FOUND'
}

/** A Prepaid balance response (payment method) */
export interface IBalance {
  readonly __typename?: 'Balance';
  /** gift card last 4 digits */
  readonly alias: Scalars['String'];
  /** dollar amount gift card begins with */
  readonly beginBalance: Scalars['Int'];
  readonly currencyCode: Scalars['String'];
  /** current gift card balance in cents */
  readonly currentBalance: Scalars['Int'];
  readonly expiryMonth: Scalars['String'];
  readonly expiryYear: Scalars['String'];
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
}

export interface IBillingAddress {
  readonly __typename?: 'BillingAddress';
  /** City */
  readonly locality: Scalars['String'];
  /** Zip Code */
  readonly postalCode: Scalars['String'];
  /** State */
  readonly region: Scalars['String'];
  /** Street Address */
  readonly streetAddress: Scalars['String'];
  /** Apt or Unit Number */
  readonly unitNumber?: Maybe<Scalars['String']>;
}

export interface IBillingAddressInput {
  /** Country */
  readonly country?: InputMaybe<Scalars['String']>;
  /** City */
  readonly locality?: InputMaybe<Scalars['String']>;
  /** Zip Code */
  readonly postalCode: Scalars['String'];
  /** State */
  readonly region?: InputMaybe<Scalars['String']>;
  /** Street Address */
  readonly streetAddress?: InputMaybe<Scalars['String']>;
  /** Apt or Unit Number */
  readonly unitNumber?: InputMaybe<Scalars['String']>;
}

export enum Brand {
  BK = 'BK',
  /** @deprecated(reason: "only BK is allowed") */
  FHS = 'FHS',
  /** @deprecated(reason: "only BK is allowed") */
  LTW = 'LTW',
  /** @deprecated(reason: "only BK is allowed") */
  PLK = 'PLK',
  /** @deprecated(reason: "only BK is allowed") */
  TH = 'TH'
}

export interface IBrazeUserPhone {
  readonly __typename?: 'BrazeUserPhone';
  readonly phone?: Maybe<Scalars['String']>;
}

/** needed for generate vr payment vault link */
export interface IBrowserInfoInput {
  readonly colorDepth: Scalars['Int'];
  readonly screenHeight: Scalars['Int'];
  readonly screenWidth: Scalars['Int'];
  readonly timeZoneOffset: Scalars['Int'];
}

export interface ICart {
  readonly __typename?: 'Cart';
  readonly appliedOffers?: Maybe<ReadonlyArray<Maybe<ICartAppliedOffer>>>;
  readonly brand: Brand;
  readonly cartEntries?: Maybe<ReadonlyArray<ICartEntries>>;
  readonly cartVersion?: Maybe<Scalars['Int']>;
  readonly customerLocale?: Maybe<Scalars['String']>;
  readonly customerName: Scalars['String'];
  readonly deviceOS?: Maybe<Scalars['String']>;
  readonly discounts?: Maybe<ReadonlyArray<Maybe<IDiscount>>>;
  readonly donations?: Maybe<ReadonlyArray<Maybe<IDonation>>>;
  readonly fees?: Maybe<ReadonlyArray<Maybe<IFees>>>;
  /** All evaluated offers in the cart, or all the offers supplied against the cart. */
  readonly offersFeedback?: Maybe<ReadonlyArray<Maybe<ICouponUserOffersFeedbackEntry>>>;
  readonly payment?: Maybe<IPayment>;
  readonly platform?: Maybe<Platform>;
  readonly posVendor: PosVendor;
  /**
   * ISO Timestamp from POS in local timezone e.g 2019-07-08T23:02:17.203Z
   * @deprecated Only for internal use
   */
  readonly processedAt?: Maybe<Scalars['String']>;
  /**
   * Cart entries for reordering.
   * This is usually the same as cartEntries except for when there are swaps.
   */
  readonly reorderCartEntries?: Maybe<ReadonlyArray<ICartEntries>>;
  readonly requestedAmountCents: Scalars['Int'];
  readonly rewardsApplied?: Maybe<ReadonlyArray<Maybe<ICartAppliedReward>>>;
  readonly serviceMode: ServiceMode;
  readonly storeAddress: IStoreAddress;
  readonly storeDetails?: Maybe<IStoreDetails>;
  readonly storeId: Scalars['String'];
  readonly storePosId?: Maybe<Scalars['String']>;
  readonly subTotalCents?: Maybe<Scalars['Int']>;
  /** @deprecated Not needed anymore since it is included in AppliedOffer */
  readonly swaps?: Maybe<ReadonlyArray<Maybe<ICartSwap>>>;
  readonly taxCents?: Maybe<Scalars['Int']>;
  readonly ticketNumber?: Maybe<Scalars['String']>;
  readonly totalCents?: Maybe<Scalars['Int']>;
  readonly unavailableCartEntries?: Maybe<ReadonlyArray<Maybe<IUnavailableCartEntry>>>;
  readonly userDetails?: Maybe<IUserDetails>;
  readonly userId?: Maybe<Scalars['String']>;
  readonly vatNumber?: Maybe<Scalars['String']>;
  readonly wasLoyaltyEarned?: Maybe<Scalars['Boolean']>;
}

export interface ICartAppliedOffer {
  readonly __typename?: 'CartAppliedOffer';
  readonly cartId?: Maybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: Maybe<Scalars['ID']>;
  readonly swap?: Maybe<ICartSwap>;
  readonly type: OfferType;
}

/** AppliedReward is duplicated here to avoid breaking changes as above definition serves as an input. */
export interface ICartAppliedReward {
  readonly __typename?: 'CartAppliedReward';
  readonly cartId: Scalars['ID'];
  readonly rewardId: Scalars['ID'];
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: Maybe<Scalars['ID']>;
  readonly timesApplied: Scalars['Int'];
}

export interface ICartEntries {
  readonly __typename?: 'CartEntries';
  readonly children?: Maybe<ReadonlyArray<Maybe<ICartEntries>>>;
  readonly image?: Maybe<Scalars['String']>;
  readonly isDonation?: Maybe<Scalars['Boolean']>;
  readonly isExtra?: Maybe<Scalars['Boolean']>;
  readonly isInMenu?: Maybe<Scalars['Boolean']>;
  readonly lineId: Scalars['String'];
  readonly name?: Maybe<Scalars['String']>;
  readonly offerVendorConfigs?: Maybe<IVendorConfigs>;
  readonly pickerSelections?: Maybe<Scalars['String']>;
  readonly plu?: Maybe<IPlu>;
  readonly price?: Maybe<Scalars['Int']>;
  readonly quantity: Scalars['Int'];
  readonly redeemable?: Maybe<Scalars['Boolean']>;
  readonly sanityId: Scalars['String'];
  readonly type: CartEntryType;
  readonly url?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
}

export interface ICartEntryInput {
  readonly children?: InputMaybe<ReadonlyArray<ICartEntryInput>>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly isDonation?: InputMaybe<Scalars['Boolean']>;
  readonly isExtra?: InputMaybe<Scalars['Boolean']>;
  readonly lineId: Scalars['String'];
  readonly markerItemPlu?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly offerVendorConfigs?: InputMaybe<IVendorConfigsInput>;
  readonly pickerSelections?: InputMaybe<Scalars['String']>;
  readonly plu?: InputMaybe<IPluInput>;
  readonly price?: InputMaybe<Scalars['Int']>;
  readonly productHierarchy?: InputMaybe<IProductHierarchyInput>;
  readonly quantity: Scalars['Int'];
  readonly sanityId: Scalars['String'];
  readonly type: CartEntryType;
  readonly url?: InputMaybe<Scalars['String']>;
  readonly vendorConfigs?: InputMaybe<IVendorConfigsInput>;
}

export enum CartEntryType {
  COMBO = 'Combo',
  COMBOSLOT = 'ComboSlot',
  ITEM = 'Item',
  ITEMOPTION = 'ItemOption',
  ITEMOPTIONMODIFIER = 'ItemOptionModifier',
  OFFERCOMBO = 'OfferCombo',
  OFFERDISCOUNT = 'OfferDiscount',
  OFFERITEM = 'OfferItem'
}

export enum CartOfferState {
  ACTIVE = 'ACTIVE',
  CONSUMED = 'CONSUMED',
  INACTIVE = 'INACTIVE'
}

export enum CartPaymentCardType {
  AMEX = 'AMEX',
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  DINERS = 'DINERS',
  DINERS_CLUB = 'DINERS_CLUB',
  DISCOVER = 'DISCOVER',
  GIFT_CARD = 'GIFT_CARD',
  GOOGLE_PAY = 'GOOGLE_PAY',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  PAYPAL = 'PAYPAL',
  VISA = 'VISA'
}

export enum CartPaymentType {
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT_ANONYMOUS = 'CREDIT_ANONYMOUS',
  GOOGLE_PAY = 'GOOGLE_PAY',
  VAULTED_ACCOUNT = 'VAULTED_ACCOUNT'
}

export interface ICartSwap {
  readonly __typename?: 'CartSwap';
  readonly cartId: Scalars['String'];
  readonly from: Scalars['String'];
  readonly swapType: Scalars['String'];
  readonly to: Scalars['String'];
}

export interface ICatering {
  readonly __typename?: 'Catering';
  readonly declineReason?: Maybe<CateringDeclineReasons>;
  readonly notes?: Maybe<Scalars['String']>;
  readonly pickupTime: Scalars['String'];
}

export enum CateringDecision {
  ACCEPT = 'Accept',
  DECLINE = 'Decline'
}

export enum CateringDeclineReasons {
  CATERING_ORDER_TIME_OUT = 'CATERING_ORDER_TIME_OUT',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVENTORY = 'INVENTORY',
  STAFFING = 'STAFFING',
  TIMING = 'TIMING'
}

export interface ICateringInfoInput {
  /**
   * Pickup Time - in ISO format.
   * Only ISO-formatted datetime values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly pickupTime: Scalars['String'];
}

export interface ICognitoCredentials {
  readonly __typename?: 'CognitoCredentials';
  readonly challengeCode: Scalars['String'];
  readonly email?: Maybe<Scalars['String']>;
  readonly sessionId: Scalars['String'];
  /** Data corresponding to user requesting credentials */
  readonly user: IUser;
}

export interface ICommitDeliveryInput {
  /**
   * drop off location for delivery (user's address)
   * this can be marked as required when launch darkly
   * flag is no longer in use
   *
   * @deprecated(reason: "needs to be named dropoff")
   */
  readonly dropOff?: InputMaybe<IDeliveryWaypointInput>;
  readonly dropoff?: InputMaybe<IDeliveryWaypointInput>;
  readonly instructions?: InputMaybe<Scalars['String']>;
  /** boolean flag to mark notification setting */
  readonly pushNotification?: InputMaybe<Scalars['Boolean']>;
  readonly tipCents?: InputMaybe<Scalars['Int']>;
}

export interface ICommitOrderInput {
  /**
   * Details from Apple Pay for payment.
   * @deprecated(reason: "Use payment object")
   */
  readonly applePayDetails?: InputMaybe<IApplePay>;
  /**
   * Billing address Comes in the following format
   * billingStreetAddress, billingApt, billingCity, billingState, billingZip
   * @deprecated(reason: "Use payment object")
   */
  readonly billingAddress?: InputMaybe<IBillingAddressInput>;
  /**
   * First 6 digits of credit card.
   * Required for anonymous payment.
   * @deprecated(reason: "Use payment object")
   * @constraint(pattern: "^[0-9]{6}$")
   */
  readonly ccBin?: InputMaybe<Scalars['String']>;
  /**
   * Credit card 2 digit expiry month
   * @deprecated(reason: "Use payment object")
   */
  readonly ccExpiryMonth?: InputMaybe<Scalars['String']>;
  /**
   * Credit card 2 digit expiry year
   * @deprecated(reason: "Use payment object")
   */
  readonly ccExpiryYear?: InputMaybe<Scalars['String']>;
  /**
   * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @deprecated(reason: "Use payment object")
   * @constraint(pattern: "^[0-9]{4}$")
   */
  readonly ccLast4?: InputMaybe<Scalars['String']>;
  /**
   * chase id from TH endpoint to trigger direct payment
   * @deprecated(reason: "Use payment object")
   */
  readonly chaseProfileId?: InputMaybe<Scalars['String']>;
  /**
   * The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX)
   * @deprecated(reason: "Use payment object")
   */
  readonly creditType?: InputMaybe<CartPaymentCardType>;
  /**
   * Valid access token for accessing First Data API
   * @deprecated(reason: "Use firstDataInput on payment object")
   */
  readonly fdAccessToken?: InputMaybe<Scalars['String']>;
  /**
   * The First Data payment method ID which must be associated to the user
   * making the request.
   * @deprecated(reason: "Use firstDataInput on payment object")
   */
  readonly fdAccountId?: InputMaybe<Scalars['String']>;
  /**
   * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce.
   * @deprecated(reason: "Use firstDataInput on payment object")
   */
  readonly fdNonce?: InputMaybe<Scalars['String']>;
  /** Takes in a time in seconds to delay the order commit */
  readonly fireOrderIn?: InputMaybe<Scalars['Int']>;
  /**
   * Customer full name
   * @deprecated(reason: "Use payment object")
   */
  readonly fullName?: InputMaybe<Scalars['String']>;
  /**
   * Details from Google Pay for payment.
   * @deprecated(reason: "Use payment object")
   */
  readonly googlePayDetails?: InputMaybe<IGooglePay>;
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   * @deprecated(reason: "Use payment object")
   */
  readonly kountSessionId?: InputMaybe<Scalars['String']>;
  /** Contains information to submit payment for this order */
  readonly payment?: InputMaybe<IPaymentInput>;
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['ID'];
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: InputMaybe<Scalars['String']>;
  /**
   * Unique Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   *
   * @deprecated(reason: "Use kountSessionId on payment object")
   */
  readonly sessionId?: InputMaybe<Scalars['String']>;
  /** Store email address */
  readonly storeEmail?: InputMaybe<Scalars['String']>;
  /** Details from 3DS transactions, relates to properties needed to resume sale transactions. */
  readonly threeDSDetails?: InputMaybe<IResumeThreeDSaleTransaction>;
}

export interface ICommunicationPreference {
  readonly __typename?: 'CommunicationPreference';
  /** Database id of the preference (i.e. language) */
  readonly id?: Maybe<Scalars['String']>;
  /** Value the preference is set to */
  readonly value?: Maybe<Scalars['String']>;
}

export interface ICommunicationPreferenceInput {
  readonly asBoolean?: InputMaybe<Scalars['Boolean']>;
  readonly asNumber?: InputMaybe<Scalars['Boolean']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly value?: InputMaybe<Scalars['String']>;
}

export interface IConfirmCateringOrderInput {
  /** Catering JWT containing catering order info */
  readonly cateringJwt: Scalars['String'];
  /** Accept or Decline Order */
  readonly decision: CateringDecision;
  /** Decline Reason */
  readonly declineReason?: InputMaybe<CateringDeclineReasons>;
}

/**
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 *
 * A connection as defined by the GraphQL Cursor Connections Specifications
 *
 * Provides totalCount if there is an efficient way to determine the total
 * pre-paginated results.
 *
 * Provides an array of nodes for consumers that do not need each node's cursor.
 */
export interface IConnection {
  readonly edges: ReadonlyArray<IEdge>;
  readonly nodes: ReadonlyArray<INode>;
  readonly pageInfo: IPageInfo;
  readonly totalCount?: Maybe<Scalars['Int']>;
}

/**
 * Coordinates is used by restaurants search to filter
 * by a radius and the current user's coordinates
 */
export interface ICoordinates {
  readonly searchRadius?: InputMaybe<Scalars['Float']>;
  readonly userLat?: InputMaybe<Scalars['Float']>;
  readonly userLng?: InputMaybe<Scalars['Float']>;
}

export enum CountryCode {
  CA = 'CA',
  CH = 'CH',
  DE = 'DE',
  GB = 'GB',
  US = 'US',
  ZA = 'ZA'
}

export interface ICoupon {
  readonly __typename?: 'Coupon';
  /** The coupon identity. */
  readonly couponId: Scalars['ID'];
  /** The ISO-formatted timestamp of when the coupon was created. */
  readonly createdAt: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon expires.
   * If the value is null, then the coupon never expires.
   */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /** The partition key, which is equal to userId. */
  readonly pk: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon was redeemed.
   * If the value is null, then the coupon has not yet been redeemed.
   */
  readonly redeemedOn?: Maybe<Scalars['String']>;
  /**
   * The current revision number of the coupon row.
   * This value is incremented every time the row is updated.
   * If this value is zero, then the row has never been revised.
   */
  readonly revision: Scalars['Int'];
  /** The sort key, which contains the version. */
  readonly sk: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon row was updated.
   * If this value matches the createdAt value, the row has never been updated.
   */
  readonly updatedAt: Scalars['String'];
  /** The identity of the user. */
  readonly userId: Scalars['ID'];
  /** An alternate sort value, allowing for ordering coupons by expiration. */
  readonly userSortKey: Scalars['String'];
}

export interface ICouponEvaluationFeedback {
  readonly __typename?: 'CouponEvaluationFeedback';
  /** The message code for the message. */
  readonly code: Scalars['String'];
  /** The result of evaluating one rule in a Coupon Rule Set. */
  readonly condition: Scalars['Boolean'];
  /** The ISO datetime when the offer expires, if applicable. */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /** The message string for the message. */
  readonly message: Scalars['String'];
  /** The number of seconds the coupon can be redeemed for, if applicable. */
  readonly redeemableForSeconds?: Maybe<Scalars['Int']>;
  /** The number of seconds before the coupon can be redeemed, if applicable. */
  readonly redeemableInSeconds?: Maybe<Scalars['Int']>;
  /** The ordinal index number of the rule set entry associated with this feedback, if provided. */
  readonly ruleSetIndex?: Maybe<Scalars['Int']>;
  /** The type of Coupon Rule Set. */
  readonly ruleSetType: Scalars['String'];
  /** The Sanity ID of this rule product or product category. */
  readonly sanityId?: Maybe<Scalars['String']>;
}

export interface ICouponListResponse {
  readonly __typename?: 'CouponListResponse';
  /**
   * The count of elements in the response.
   * If this value is zero, there were no matching coupons.
   */
  readonly count: Scalars['Int'];
  /**
   * The set of coupons retrieved.
   * If this array is empty, there were no matching coupons.
   */
  readonly coupons: ReadonlyArray<Maybe<ICoupon>>;
  /**
   * A resume point for a subsequent call.
   * If this value is undefined or null, there are no more coupons.
   * Specify this value on a subsequent call to continue paginating through coupons.
   */
  readonly resumeAfter?: Maybe<Scalars['String']>;
}

export interface ICouponRedemptionEligibility {
  readonly __typename?: 'CouponRedemptionEligibility';
  /** Any feedback provided during evaluation, further describing the condition. */
  readonly evaluationFeedback: ReadonlyArray<Maybe<ICouponEvaluationFeedback>>;
  /** The ISO datetime when the offer expires, if applicable. */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /**
   * The overall redemption eligibility condition.
   * Only a Coupon Rule Set which can be parsed and is valid will potentially be redeemable.
   * If the offer is a Loyalty offer which is not active, then it will also not be redeemable.
   */
  readonly isRedeemable: Scalars['Boolean'];
  /**
   * Whether the Coupon Rule Set structure and data is valid for evaluation.
   * A Coupon Rule Set which is not valid is not redeemable.
   */
  readonly isValid: Scalars['Boolean'];
  /** The redemption eligibility includes the specified moment of redemption. */
  readonly redeemedOn: Scalars['String'];
  /** Any errors which were encountered during Coupon Rule Set validation. */
  readonly validationErrors: ReadonlyArray<Maybe<ICouponValidationError>>;
}

export interface ICouponToken {
  readonly __typename?: 'CouponToken';
  /** Brief description on the situation that caused coupon to be issued */
  readonly comments?: Maybe<Scalars['String']>;
  /** The coupon identity associated with the coupon token. */
  readonly couponId: Scalars['ID'];
  /** The ISO-formatted timestamp of when the coupon token was created. */
  readonly createdAt: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon token expires.
   * If the value is null, then the coupon token never expires.
   */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /** The partition key, which is equal to userId. */
  readonly pk: Scalars['String'];
  /** Reason for issuing the coupon */
  readonly reason?: Maybe<Scalars['String']>;
  /** The id of the support agent who issue'd this coupon */
  readonly supportCognitoId?: Maybe<Scalars['String']>;
  /** The email of the support agent who issue'd this coupon */
  readonly supportEmail?: Maybe<Scalars['String']>;
  /** The identity of the coupon token. */
  readonly tokenId: Scalars['ID'];
  /** The identity of the user owning the coupon token. */
  readonly userId: Scalars['ID'];
}

export interface ICouponTokenListResponse {
  readonly __typename?: 'CouponTokenListResponse';
  /**
   * The count of elements in the response.
   * If this value is zero, there were no matching coupon tokens.
   */
  readonly count: Scalars['Int'];
  /**
   * A resume point for a subsequent call.
   * If this value is undefined or null, there are no more coupons.
   * Specify this value on a subsequent call to continue paginating through coupons.
   */
  readonly resumeAfter?: Maybe<Scalars['String']>;
  /**
   * The set of coupon tokens retrieved.
   * If this array is empty, there were no matching coupon tokens.
   */
  readonly tokens: ReadonlyArray<Maybe<ICouponToken>>;
}

export interface ICouponUserOffersFeedback {
  readonly __typename?: 'CouponUserOffersFeedback';
  /** The cart that was evaluated, if any. */
  readonly cart?: Maybe<ICart>;
  /** All the feedback collected. */
  readonly offersFeedback: ReadonlyArray<Maybe<ICouponUserOffersFeedbackEntry>>;
}

export interface ICouponUserOffersFeedbackEntry {
  readonly __typename?: 'CouponUserOffersFeedbackEntry';
  /**
   * If the offers evaluated are sourced from the cart, this is the cart entry offer.
   * Otherwise, this field is null.
   */
  readonly cartEntry?: Maybe<ICartEntries>;
  /**
   * The identity of the coupon.
   * This may be an empty string in the event there is no couponId.
   */
  readonly couponId: Scalars['String'];
  /** If truthy, then this offer was included by Loyalty. */
  readonly isLoyalty?: Maybe<Scalars['Boolean']>;
  /** The stringified sanity offer data. */
  readonly offerDetails?: Maybe<Scalars['String']>;
  /** The current state of the offer, if applicable. */
  readonly offerState?: Maybe<CartOfferState>;
  /** Templated variables for loyalty offer. */
  readonly offerVariables?: Maybe<ReadonlyArray<Maybe<IOfferVariable>>>;
  /**
   * A weight for the offer, if applicable.
   * In the case of Tim Hortons Loyalty, this value may
   * be used to set priority status for the offer.
   */
  readonly rank?: Maybe<Scalars['Int']>;
  /** The eligibility of redemption for the coupon. */
  readonly redemptionEligibility: ICouponRedemptionEligibility;
  /**
   * The token identifier associated with the offer, if applicable.
   * In the case of Tim Hortons Loyalty, this identifier can be used to activate an
   * offer which is not currently active.
   */
  readonly tokenId?: Maybe<Scalars['String']>;
}

export interface ICouponValidationError {
  readonly __typename?: 'CouponValidationError';
  /** The message code for the message. */
  readonly code: Scalars['String'];
  /** The message string for the message. */
  readonly message: Scalars['String'];
  /** The type of Coupon Rule Set. */
  readonly ruleSetType: Scalars['String'];
}

export interface ICreateOtp {
  readonly __typename?: 'CreateOTP';
  /**
   * The maximum validation attempts allowed for the created OTP
   * @deprecated Use maxValidateAttempts
   */
  readonly maxLoginAttempts: Scalars['Int'];
  /** The maximum validation attempts allowed for the created OTP */
  readonly maxValidateAttempts: Scalars['Int'];
  /** Whether the login has been performed in US and requires redirection */
  readonly redirectToUS?: Maybe<Scalars['Boolean']>;
  /** The time-to-live for the one-time password, in seconds */
  readonly ttl: Scalars['Int'];
}

export interface ICreateOtpInput {
  /**
   * The email of the user requesting a One-Time Password. Only one of either
   * email or phoneNumber can be provided. One or the other is required.
   * @todo - only email is implemented at this time
   */
  readonly email?: InputMaybe<Scalars['String']>;
  /**
   * The phone number of the user requesting a One-Time Password. Only one of either
   * email or phoneNumber can be provided. One or the other is required.
   * @todo - not implemented
   */
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  /** Requestor's platform */
  readonly platform: Platform;
  /**
   * A unique identifier to associate with the one-time password, to be provided on
   * validation attempts
   */
  readonly sessionId: Scalars['ID'];
}

export interface ICreditCard {
  readonly __typename?: 'CreditCard';
  /** Credit card last 4 digits */
  readonly alias: Scalars['String'];
  readonly billingAddress?: Maybe<IBillingAddress>;
  /** Card Provider */
  readonly cardType: Scalars['String'];
  /** Two digit expiry month */
  readonly expiryMonth: Scalars['String'];
  /** Two digit expiry year */
  readonly expiryYear: Scalars['String'];
  readonly fullName: Scalars['String'];
  /**
   * First Data credit card token.
   *
   * Should be a numeric string, whose last 4 digits match the credit card alias.
   */
  readonly panToken?: Maybe<Scalars['String']>;
}

export interface ICreditCardMetadataInput {
  /**
   * First 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{6}$")
   */
  readonly ccBin?: InputMaybe<Scalars['String']>;
  /** Credit card 2 digit expiry month */
  readonly ccExpiryMonth?: InputMaybe<Scalars['String']>;
  /** Credit card 2 digit expiry year */
  readonly ccExpiryYear?: InputMaybe<Scalars['String']>;
  /**
   * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{4}$")
   */
  readonly ccLast4?: InputMaybe<Scalars['String']>;
  /** The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX) */
  readonly creditType?: InputMaybe<CartPaymentCardType>;
}

/**  USD/840 CAD/124 */
export interface ICurrencyCode {
  readonly __typename?: 'CurrencyCode';
  readonly code: Scalars['String'];
  readonly number: Scalars['Int'];
}

export interface IDay {
  readonly __typename?: 'Day';
  readonly close?: Maybe<Scalars['String']>;
  readonly open?: Maybe<Scalars['String']>;
}

export interface IDayPart {
  readonly __typename?: 'DayPart';
  readonly displayName?: Maybe<Scalars['String']>;
  readonly hours?: Maybe<IOperatingHours>;
  readonly key?: Maybe<Scalars['String']>;
}

/** Delete an account (payment method) from the current user */
export interface IDeleteAccountInput {
  /**
   * Represents a saved funding source. (i.e. fdAccountId or recurringDetailReference)
   * Use this field instead.
   */
  readonly accountIdentifier?: InputMaybe<Scalars['String']>;
  /** Account ID for account to be deleted */
  readonly fdAccountId?: InputMaybe<Scalars['String']>;
}

export interface IDelivery {
  readonly __typename?: 'Delivery';
  readonly assignedFleetName?: Maybe<Scalars['String']>;
  readonly baseDeliveryFeeCents?: Maybe<Scalars['Int']>;
  readonly cancellation?: Maybe<IDeliveryCancellation>;
  readonly customerId?: Maybe<Scalars['String']>;
  readonly deliverySurchargeFeeCents?: Maybe<Scalars['Int']>;
  readonly driver?: Maybe<IDeliveryDriver>;
  readonly dropoff: IDeliveryWaypoint;
  readonly estimateId?: Maybe<Scalars['String']>;
  readonly expiration?: Maybe<Scalars['String']>;
  readonly feeCents: Scalars['Int'];
  readonly feeDiscountCents?: Maybe<Scalars['Int']>;
  readonly fleetId?: Maybe<Scalars['String']>;
  readonly geographicalFeeCents?: Maybe<Scalars['Int']>;
  readonly instructions?: Maybe<Scalars['String']>;
  readonly pickup: IDeliveryWaypoint;
  readonly quoteId?: Maybe<Scalars['String']>;
  readonly quotedFeeCents?: Maybe<Scalars['Int']>;
  readonly serviceFeeCents?: Maybe<Scalars['Int']>;
  readonly shareUuid?: Maybe<Scalars['String']>;
  readonly smallCartFeeCents?: Maybe<Scalars['Int']>;
  readonly status: DeliveryStatus;
  readonly task?: Maybe<IDeliveryTaskDetails>;
  readonly tipCents?: Maybe<Scalars['Int']>;
  readonly userId?: Maybe<Scalars['String']>;
}

export interface IDeliveryAddress {
  readonly __typename?: 'DeliveryAddress';
  /** Address Line limited to 150 chars */
  readonly addressLine1: Scalars['String'];
  /** Address Line 2 limited to 150 chars */
  readonly addressLine2?: Maybe<Scalars['String']>;
  /** Alias to identify an address e.g home, office etc */
  readonly alias?: Maybe<Scalars['String']>;
  /** city name limited to 150 chars */
  readonly city: Scalars['String'];
  /** isoCountryCode */
  readonly country?: Maybe<IsoCountryCode>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  /** 10 digit phone number spaces don't matter */
  readonly phoneNumber: Scalars['String'];
  readonly route?: Maybe<Scalars['String']>;
  /** state abbreviation FL, GA, etc */
  readonly state?: Maybe<Scalars['String']>;
  readonly streetNumber?: Maybe<Scalars['String']>;
  /** zipCode 5-10 digits no spaces */
  readonly zip?: Maybe<Scalars['String']>;
}

export interface IDeliveryCancellation {
  readonly __typename?: 'DeliveryCancellation';
  readonly description?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['Int']>;
  readonly text?: Maybe<Scalars['String']>;
}

export interface IDeliveryDriver {
  readonly __typename?: 'DeliveryDriver';
  readonly name?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly profileImageUrl?: Maybe<Scalars['String']>;
}

export interface IDeliveryRestaurant {
  readonly __typename?: 'DeliveryRestaurant';
  /** Restaurant delivery surcharge fee cents. */
  readonly deliverySurchargeFeeCents?: Maybe<Scalars['Int']>;
  /** Next available delivery time for store */
  readonly nextEarliestOpen?: Maybe<Scalars['String']>;
  /** Status of delivery order */
  readonly quote?: Maybe<DeliveryStatus>;
  /** the quoteId related to the current delivery restaurant */
  readonly quoteId?: Maybe<Scalars['String']>;
  /** Extended restaurant data containing all fields from Sanity + Dynamo */
  readonly restaurant?: Maybe<IRestaurantNode>;
  /** Status of delivery store */
  readonly storeStatus: DeliveryStoreStatus;
}

export enum DeliveryStatus {
  DRIVER_ASSIGNED = 'DRIVER_ASSIGNED',
  DRIVER_AT_CUSTOMER = 'DRIVER_AT_CUSTOMER',
  DRIVER_AT_STORE = 'DRIVER_AT_STORE',
  DRIVER_STARTING = 'DRIVER_STARTING',
  DRIVER_UNASSIGNED = 'DRIVER_UNASSIGNED',
  ORDER_ABANDONED = 'ORDER_ABANDONED',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_DROPPED_OFF = 'ORDER_DROPPED_OFF',
  ORDER_ERROR = 'ORDER_ERROR',
  ORDER_PICKED_UP = 'ORDER_PICKED_UP',
  ORDER_TIMEOUT = 'ORDER_TIMEOUT',
  QUOTE_ERROR = 'QUOTE_ERROR',
  QUOTE_REQUESTED = 'QUOTE_REQUESTED',
  QUOTE_SUCCESSFUL = 'QUOTE_SUCCESSFUL',
  QUOTE_UNAVAILABLE = 'QUOTE_UNAVAILABLE'
}

export enum DeliveryStoreStatus {
  CLOSED = 'CLOSED',
  NO_DELIVERY = 'NO_DELIVERY',
  OPEN = 'OPEN'
}

export interface IDeliveryTaskDetails {
  readonly __typename?: 'DeliveryTaskDetails';
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly uuid?: Maybe<Scalars['String']>;
}

export interface IDeliveryWaypoint {
  readonly __typename?: 'DeliveryWaypoint';
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly afterTime?: Maybe<Scalars['String']>;
  readonly arrivalTime?: Maybe<Scalars['String']>;
  readonly beforeTime?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly phoneNumber: Scalars['String'];
  readonly shareUuid?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly trackingUrl?: Maybe<Scalars['String']>;
  readonly zip?: Maybe<Scalars['String']>;
}

export interface IDeliveryWaypointInput {
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: InputMaybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country?: InputMaybe<Scalars['String']>;
  readonly latitude?: InputMaybe<Scalars['Float']>;
  readonly longitude?: InputMaybe<Scalars['Float']>;
  readonly phoneNumber: Scalars['String'];
  readonly route?: InputMaybe<Scalars['String']>;
  /** flag to determine wether or not the waypoint should be saved */
  readonly shouldSave?: InputMaybe<Scalars['Boolean']>;
  readonly state?: InputMaybe<Scalars['String']>;
  readonly streetNumber?: InputMaybe<Scalars['String']>;
  readonly zip?: InputMaybe<Scalars['String']>;
}

export interface IDiscount {
  readonly __typename?: 'Discount';
  readonly name?: Maybe<DiscountTypes>;
  /** values are represented as positive integers in cents */
  readonly value?: Maybe<Scalars['Int']>;
}

export enum DiscountTypes {
  ALL_DISCOUNTS = 'ALL_DISCOUNTS',
  COMBO_AND_OFFER_DISCOUNTS = 'COMBO_AND_OFFER_DISCOUNTS',
  REWARDS_DISCOUNTS = 'REWARDS_DISCOUNTS'
}

export interface IDonation {
  readonly __typename?: 'Donation';
  readonly id?: Maybe<Scalars['String']>;
  /** Name of donation */
  readonly name?: Maybe<Scalars['String']>;
  /** Total are represented as positive integers in cents */
  readonly totalCents?: Maybe<Scalars['Int']>;
}

/**
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 *
 * An edge provides an association between a node and it's associated cursor.
 */
export interface IEdge {
  readonly cursor: Scalars['String'];
  readonly node: INode;
}

/** All details necessary to encrypt CC information for First Data */
export interface IEncryptionDetails {
  readonly __typename?: 'EncryptionDetails';
  /**
   * Encryption algorithm.
   *
   * You should be able to ignore this value, as we only support 'RSA/NONE/PKCS1Padding'
   */
  readonly algorithm?: Maybe<Scalars['String']>;
  /** Access token for accessing First Data API. Limited TTL. */
  readonly fdAccessToken: Scalars['String'];
  /** RBI specific API key for accessing First Data */
  readonly fdApiKey: Scalars['String'];
  /** First data customer ID. Derived from provided authentication header. */
  readonly fdCustomerId?: Maybe<Scalars['String']>;
  /** Public key for performing RSA encryption on specific First Data requests */
  readonly fdPublicKey: Scalars['String'];
  /** Time until public key expires (milliseconds?) */
  readonly fdPublicKeyExpiresInSeconds: Scalars['Int'];
  /** ISO datetime for when public key was issued */
  readonly fdPublicKeyIssuesOn: Scalars['String'];
}

export interface IEntitlementConsentListItem {
  readonly __typename?: 'EntitlementConsentListItem';
  readonly EntitlementConsentStatus: Scalars['String'];
  readonly EntitlementDescription: Scalars['String'];
  readonly EntitlementDisplayName: Scalars['String'];
  readonly EntitlementGroup: Scalars['String'];
  readonly EntitlementShortName: Scalars['String'];
}

export interface IEntitlementListItem {
  readonly __typename?: 'EntitlementListItem';
  readonly EntitlementDisplayName: Scalars['String'];
  readonly EntitlementGroup: Scalars['String'];
  readonly EntitlementShortName: Scalars['String'];
  readonly LegalTeaserText: Scalars['String'];
  readonly LegalText: Scalars['String'];
}

export interface IExchangeOtpCodeForCredentialsInput {
  /** The code associated with the user's current OTP, for validation */
  readonly code: Scalars['String'];
  /**
   * The email of the user requesting a One-Time Password. Optional, one of either
   * email or phoneNumber must always be provided
   * @todo - only email is implemented at this time
   */
  readonly email?: InputMaybe<Scalars['String']>;
  /**
   * The phone number of the user logging in with a One-Time Password. Optional, one of either
   * email or phoneNumber must always be provided.
   * @todo - not implemented
   */
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  /** The unique identifier provided when the OTP was created */
  readonly sessionId: Scalars['ID'];
}

export interface IFavorite {
  readonly __typename?: 'Favorite';
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly entries?: Maybe<ReadonlyArray<Maybe<ICartEntries>>>;
  readonly favoriteId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly ref?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['String']>;
}

export interface IFavoriteInput {
  readonly entries?: InputMaybe<ReadonlyArray<InputMaybe<ICartEntryInput>>>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly ref?: InputMaybe<Scalars['String']>;
}

export interface IFavoriteList {
  readonly __typename?: 'FavoriteList';
  readonly count?: Maybe<Scalars['Int']>;
  readonly favorites?: Maybe<ReadonlyArray<Maybe<IFavorite>>>;
  readonly resumeAfter?: Maybe<Scalars['String']>;
}

export interface IFavoriteOffer {
  readonly __typename?: 'FavoriteOffer';
  /** Favorite Offer ID */
  readonly id?: Maybe<Scalars['String']>;
}

export interface IFavoriteOfferInput {
  readonly id?: InputMaybe<Scalars['String']>;
}

export interface IFavoriteStore {
  readonly __typename?: 'FavoriteStore';
  /** Favorite Store ID */
  readonly storeId?: Maybe<Scalars['String']>;
  /** Favorite Store Number */
  readonly storeNumber?: Maybe<Scalars['String']>;
}

export interface IFavoriteStoreInput {
  readonly storeId?: InputMaybe<Scalars['String']>;
  readonly storeNumber?: InputMaybe<Scalars['String']>;
}

export interface IFavoriteStoreSignUpInput {
  readonly storeId?: InputMaybe<Scalars['String']>;
  readonly storeNumber: Scalars['String'];
}

export interface IFees {
  readonly __typename?: 'Fees';
  readonly name?: Maybe<Scalars['String']>;
  readonly priceCents?: Maybe<Scalars['Int']>;
  readonly quantity?: Maybe<Scalars['Int']>;
  readonly totalCents?: Maybe<Scalars['Int']>;
}

export enum FilterRestaurantType {
  FAVORITE = 'FAVORITE',
  NEARBY = 'NEARBY',
  RECENT = 'RECENT'
}

export interface IFirstDataPayment {
  /**
   * Represents a saved funding source. (i.e. fdAccountId or recurringDetailReference)
   * If passed this will be used to process payment. Either accountIdentifier or fdNonce
   * and fdAccessToken should be passed.
   */
  readonly accountIdentifier?: InputMaybe<Scalars['String']>;
  /** Valid access token for accessing First Data API */
  readonly fdAccessToken?: InputMaybe<Scalars['String']>;
  /**
   * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce. If accountIdentifier is not passed this must
   * be passed.
   */
  readonly fdNonce?: InputMaybe<Scalars['String']>;
  /** Whether to store payment method or not */
  readonly storePaymentMethod?: InputMaybe<Scalars['Boolean']>;
}

export interface IFulfillmentDetails {
  readonly __typename?: 'FulfillmentDetails';
  readonly pickupPin?: Maybe<Scalars['String']>;
  readonly pickupReady?: Maybe<Scalars['Boolean']>;
  readonly pickupType?: Maybe<FulfillmentPickupType>;
}

export enum FulfillmentPickupType {
  BEEPER = 'BEEPER',
  LOCKER = 'LOCKER'
}

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

/** A First Data gift card account (prepaid payment method) */
export interface IGiftAccount {
  readonly __typename?: 'GiftAccount';
  /** First Data account ID */
  readonly fdAccountId: Scalars['String'];
  readonly prepaid: IGiftCard;
}

/** First Data prepaid account */
export interface IGiftCard {
  readonly __typename?: 'GiftCard';
  /** last 4 digits of prepaid gift card number */
  readonly alias: Scalars['String'];
  readonly cardNumber: Scalars['String'];
  /** amount card was loaded with (cents) upon creation */
  readonly currentBalance?: Maybe<Scalars['Int']>;
  /** Two digit expiry month */
  readonly expiryMonth: Scalars['String'];
  /** Two digit expiry year */
  readonly expiryYear: Scalars['String'];
  readonly feFormattedCurrentBalance?: Maybe<Scalars['Int']>;
  /** Use to generate barcode */
  readonly shuffledCardNumber: Scalars['String'];
}

export interface IGiftOffer {
  readonly __typename?: 'GiftOffer';
  /** The cost in points to redeem */
  readonly costInPoints: Scalars['Int'];
  /** Can the Gift Offer be redeemed. */
  readonly isRedeemable: Scalars['Boolean'];
  /** The offer identity. */
  readonly offerId: Scalars['ID'];
  /** The title as a string */
  readonly title: Scalars['String'];
  /** The title formatted with points required, e.g. "Free Coffee (50 Points)" */
  readonly titleFormatted: Scalars['String'];
}

export interface IGiftOfferInput {
  /** The name the offer will come from */
  readonly fromName: Scalars['String'];
  /** The message to include in the email */
  readonly message: Scalars['String'];
  /** The Id of the offer to gift */
  readonly offerId: Scalars['String'];
  /** The email address to send the offer to */
  readonly toEmail: Scalars['String'];
}

export interface IGiftOfferListResponse {
  readonly __typename?: 'GiftOfferListResponse';
  /**
   * The count of elements in the response.
   * If this value is zero, there were no matching coupons.
   */
  readonly count: Scalars['Int'];
  /**
   * The set of offers retrieved.
   * If this array is empty, there were no matching coupons.
   */
  readonly offers: ReadonlyArray<Maybe<IGiftOffer>>;
}

/** Details from Google Pay used for Google Pay funding. */
export interface IGooglePay {
  /** Data of the payment method used for Google Pay. */
  readonly PaymentMethodData?: InputMaybe<IPaymentMethodData>;
  /** Billing address from Google Pay */
  readonly billingAddress: IBillingAddressInput;
  /** Country Code from user account */
  readonly country: CountryCode;
  /** Signature message passed through from Google Pay */
  readonly data: Scalars['String'];
  /** Formatted billing address from Google Pay */
  readonly formatted: Scalars['String'];
  /** Encrypted token including signature and signature message as passed through from Google Pay. */
  readonly paymentData?: InputMaybe<Scalars['String']>;
  readonly primary: Scalars['Boolean'];
  /** Signature as passed through from Google Pay */
  readonly signature: Scalars['String'];
  readonly type: Scalars['String'];
  readonly version: Scalars['String'];
}

export enum ITicketStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN'
}

export interface IInstagramImage {
  readonly __typename?: 'InstagramImage';
  readonly media_type: MediaType;
  /** An instagram image */
  readonly media_url: Scalars['String'];
  readonly timestamp: Scalars['String'];
  readonly username: Scalars['String'];
}

export { IsoCountryCode };

export interface IItem {
  readonly id?: InputMaybe<Scalars['String']>;
  readonly quantity?: InputMaybe<Scalars['Int']>;
}

export enum Locale {
  CA = 'ca',
  CS = 'cs',
  DE = 'de',
  EN = 'en',
  ES = 'es',
  EU = 'eu',
  FR = 'fr',
  GL = 'gl',
  ID = 'id',
  IT = 'it',
  JA = 'ja',
  JV = 'jv',
  KO = 'ko',
  ML = 'ml',
  MS = 'ms',
  NL = 'nl',
  PA = 'pa',
  PL = 'pl',
  PT = 'pt',
  RO = 'ro',
  TA = 'ta',
  TE = 'te',
  TH = 'th',
  ZH = 'zh'
}

export interface ILoyaltyBalance {
  readonly amount: Scalars['Float'];
  readonly currency: Scalars['String'];
}

export interface ILoyaltyCard {
  readonly __typename?: 'LoyaltyCard';
  readonly barcode: Scalars['String'];
  readonly cardFormat: UserCardCardFormat;
  /**
   * 12 digit card number, eg '1G96025DZ9ZG'.
   *
   * This is the number printed on the back of a physical card
   */
  readonly cardId: Scalars['String'];
  readonly cardType: UserCardCardType;
  readonly name: Scalars['String'];
  readonly status: UserCardCardStatus;
}

export interface ILoyaltyCardApplePass {
  readonly __typename?: 'LoyaltyCardApplePass';
  readonly encodedPass: Scalars['String'];
}

export interface ILoyaltyCardDetails {
  readonly __typename?: 'LoyaltyCardDetails';
  /** The number of available redemptions available to the user. */
  readonly availableRedemptions: Scalars['Int'];
  /** The value of the loyalty card barcode. */
  readonly barcode?: Maybe<Scalars['String']>;
  /** Specifies whether a user is eligible to earn a reward visit. */
  readonly canEarnVisit: Scalars['Boolean'];
  /** Specifies whether a user is eligible to redeem a reward. */
  readonly canRedeemReward: Scalars['Boolean'];
  /** The type of loyalty card. */
  readonly cardType: UserCardCardType;
  /** (e.g. 0001-01-01T00:00:00.000Z) */
  readonly discountActiveUntil?: Maybe<Scalars['String']>;
  /** The donation status for a loyalty user card */
  readonly donationUpcharge?: Maybe<Scalars['Boolean']>;
  readonly numberOfTransactionsInTimePeriod: Scalars['Int'];
  /** The total number of visits this loyalty card has been issued towards the next reward. */
  readonly numberOfTransactionsMadeTowardsNextReward: Scalars['Int'];
  /** The total number of visits a loyalty card needs to be issues a reward. */
  readonly numberOfTransactionsNeeded: Scalars['Int'];
  /** The total number of offers attached to a loyalty card. */
  readonly offers: ReadonlyArray<Maybe<ILoyaltyOffer>>;
  /** (e.g. 9899-12-31T23:59:59.999Z) */
  readonly periodEndTimestamp: Scalars['String'];
  /** (e.g. 1999-01-01T00:00:00.000Z) */
  readonly periodStartTimestamp: Scalars['String'];
  /** The user's point expiry data. */
  readonly pointExpiry: ReadonlyArray<ILoyaltyPointExpiry>;
  /**
   * The user's available loyalty points.
   * If the value is null, then the user has not been migrated to Loyalty 2.0
   */
  readonly points?: Maybe<Scalars['Int']>;
  /**
   * The user's selected reward tier.
   * If the value is null, then the user has not been migrated to Loyalty 2.0
   */
  readonly rewardsTier?: Maybe<Scalars['String']>;
  /** The scan and pay status for a loyalty user card */
  readonly scanAndPay?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyCardDetailsKiosk {
  readonly __typename?: 'LoyaltyCardDetailsKiosk';
  /** The number of available redemptions available to the user. */
  readonly availableRedemptions: Scalars['Int'];
  /** ??? */
  readonly currentPoints: Scalars['Int'];
  /** The total number of visits issues to this loyalty card in an unknown period of time. */
  readonly numberOfTransactionsInTimePeriod: Scalars['Int'];
  /** The total number of visits this loyalty card has been issued towards the next reward. */
  readonly numberOfTransactionsMadeTowardsNextReward: Scalars['Int'];
  /** The total number of visits a loyalty card needs to be issues a reward. */
  readonly numberOfTransactionsNeeded: Scalars['Int'];
}

export interface ILoyaltyCardGooglePass {
  readonly __typename?: 'LoyaltyCardGooglePass';
  readonly jwt: Scalars['String'];
}

export interface ILoyaltyCardTransaction {
  readonly __typename?: 'LoyaltyCardTransaction';
  /** The taxes of the basket. */
  readonly basketTaxes?: Maybe<Scalars['Int']>;
  /** The total of the basket including taxes. */
  readonly basketTotal?: Maybe<Scalars['Int']>;
  /** Bonus points earned */
  readonly bonusPoints?: Maybe<Scalars['Int']>;
  /** City of store where loyalty was redeemed */
  readonly city?: Maybe<Scalars['String']>;
  /** The total amount discounted */
  readonly discountAmount?: Maybe<Scalars['Int']>;
  readonly expiredPoints?: Maybe<ILoyaltyExpiredPoints>;
  /** True if this visit was given from customer support. False otherwise. */
  readonly isCustomerServiceVisit?: Maybe<Scalars['Boolean']>;
  /** True if the transaction counted as a visit. */
  readonly isVisit?: Maybe<Scalars['Boolean']>;
  /** Offer that was associated with the transaction */
  readonly offerId?: Maybe<Scalars['Int']>;
  /** Loyalty points earned from transaction */
  readonly pointsEarned?: Maybe<Scalars['Int']>;
  /** Loyalty points used from transaction */
  readonly pointsUsed?: Maybe<Scalars['Int']>;
  /** True if this transaction earned a rewards */
  readonly rewardEarned?: Maybe<Scalars['Boolean']>;
  /** Reward redeemed upon transaction */
  readonly rewardRedeemed?: Maybe<Scalars['Boolean']>;
  /** State or Province of store where loyalty was redeemed */
  readonly stateOrProvince?: Maybe<Scalars['String']>;
  /** Store ID where loyalty was redeemed */
  readonly storeId?: Maybe<Scalars['String']>;
  /**
   * Tag string indicating the source of the rewards earned
   * e.g. FREQUENCY_CHALLENGE_COMPLETE, HOCKEY_1
   */
  readonly tag?: Maybe<Scalars['String']>;
  /** The time of the transaction in UTC. */
  readonly timestamp?: Maybe<Scalars['String']>;
  /** A unique identifier for transaction */
  readonly transactionId?: Maybe<Scalars['String']>;
  /**
   * A tag for the type of visit. This will be null for normal transactions.
   * When a visit or reward is issued through the IssueVisit/IssueReward endpoints
   * a VisitType may be specified that will surface in this field
   */
  readonly visitType?: Maybe<Scalars['String']>;
  /**
   * True if the discount was active or available for this transaction.
   * False if no discount was applied.
   */
  readonly wasDiscountActive?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyCardTransactions {
  readonly __typename?: 'LoyaltyCardTransactions';
  readonly count: Scalars['Int'];
  readonly transactions: ReadonlyArray<Maybe<ILoyaltyCardTransaction>>;
}

export interface ILoyaltyCardWithDetails {
  readonly __typename?: 'LoyaltyCardWithDetails';
  /** String representing the QR code data for the loyalty card */
  readonly barcode: Scalars['String'];
  /** Specifies whether a user is eligible to earn a reward visit. */
  readonly canEarnVisit: Scalars['Boolean'];
  /** Specifies whether a user is eligible to redeem a reward. */
  readonly canRedeemReward: Scalars['Boolean'];
  readonly cardFormat: UserCardCardFormat;
  /**
   * 12 digit card number, eg '1G96025DZ9ZG'.
   *
   * This is the number printed on the back of a physical card
   */
  readonly cardId: Scalars['String'];
  /** The donation status for a loyalty user card */
  readonly donationUpcharge?: Maybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
  /** The total number of offers attached to a loyalty card. */
  readonly offers: ReadonlyArray<Maybe<ILoyaltyOffer>>;
  /** The user's point expiry data. */
  readonly pointExpiry: ReadonlyArray<ILoyaltyPointExpiry>;
  /**
   * The user's available loyalty points.
   * If the value is null, then the user has not been migrated to Loyalty 2.0
   */
  readonly points?: Maybe<Scalars['Int']>;
  /**
   * The user's selected reward tier.
   * If the value is null, then the user has not been migrated to Loyalty 2.0
   */
  readonly rewardsTier?: Maybe<Scalars['String']>;
  /** The scan and pay status for a loyalty user card */
  readonly scanAndPay?: Maybe<Scalars['Boolean']>;
  readonly status: UserCardCardStatus;
}

export interface ILoyaltyCardsResp {
  readonly __typename?: 'LoyaltyCardsResp';
  readonly cards: ReadonlyArray<Maybe<ILoyaltyCard>>;
  readonly count: Scalars['Int'];
}

export interface ILoyaltyCardsWithDetailsResp {
  readonly __typename?: 'LoyaltyCardsWithDetailsResp';
  readonly cards: ReadonlyArray<Maybe<ILoyaltyCardWithDetails>>;
  readonly count: Scalars['Int'];
}

export interface ILoyaltyDonationUpcharge {
  readonly __typename?: 'LoyaltyDonationUpcharge';
  readonly donationUpcharge?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyExpiredPoints {
  readonly __typename?: 'LoyaltyExpiredPoints';
  /** Loyalty card barcode */
  readonly barcode?: Maybe<Scalars['String']>;
  readonly expirationDate?: Maybe<Scalars['String']>;
  readonly points?: Maybe<Scalars['Int']>;
  readonly ttl?: Maybe<Scalars['String']>;
}

export interface ILoyaltyOffer {
  readonly __typename?: 'LoyaltyOffer';
  readonly activated: Scalars['Boolean'];
  readonly challengeReward?: Maybe<ILoyaltyOfferRewardType>;
  readonly challengeStatus?: Maybe<ReadonlyArray<Maybe<ILoyaltyOfferChallengeStatus>>>;
  readonly challengeType?: Maybe<Scalars['String']>;
  readonly expiryDate: Scalars['String'];
  readonly key?: Maybe<Scalars['String']>;
  readonly offerId: Scalars['String'];
  readonly startDate: Scalars['String'];
}

export interface ILoyaltyOfferChallengeStatus {
  readonly __typename?: 'LoyaltyOfferChallengeStatus';
  readonly goalId: Scalars['String'];
  readonly goals?: Maybe<ILoyaltyOfferGoalType>;
  readonly reward?: Maybe<ILoyaltyOfferRewardType>;
  readonly status: Scalars['String'];
}

export interface ILoyaltyOfferGoalType {
  readonly __typename?: 'LoyaltyOfferGoalType';
  readonly category?: Maybe<Scalars['String']>;
  readonly daypart?: Maybe<Scalars['String']>;
  readonly foodType?: Maybe<Scalars['String']>;
  readonly minSpend?: Maybe<Scalars['Int']>;
}

export interface ILoyaltyOfferRewardType {
  readonly __typename?: 'LoyaltyOfferRewardType';
  readonly points?: Maybe<Scalars['Int']>;
}

export interface ILoyaltyPointExpiry {
  readonly __typename?: 'LoyaltyPointExpiry';
  readonly expirationDate: Scalars['String'];
  readonly points: Scalars['Int'];
}

export interface ILoyaltyRewardsTier {
  readonly __typename?: 'LoyaltyRewardsTier';
  readonly rewardsTier?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRollUpTheRimPrizeStats {
  readonly __typename?: 'LoyaltyRollUpTheRimPrizeStats';
  /** Total number of prizes awarded to guests for contest period. */
  readonly awarded?: Maybe<Scalars['Int']>;
  /** Prize identifier */
  readonly prizeId?: Maybe<Scalars['String']>;
  /** Total number of prizes allocated for contest period. For prizes with no cap, total will be undefined. */
  readonly total?: Maybe<Scalars['Int']>;
}

export interface ILoyaltyRollUpTheRimPrizesStats {
  readonly __typename?: 'LoyaltyRollUpTheRimPrizesStats';
  /** Cumulative sum of all prizes awarded to guests for contest period. */
  readonly awarded?: Maybe<Scalars['Int']>;
  /** Prizes */
  readonly details?: Maybe<ReadonlyArray<Maybe<ILoyaltyRollUpTheRimPrizeStats>>>;
  /** Cumulative sum of all prizes for contest period (not including unlimited prizes) */
  readonly total?: Maybe<Scalars['Int']>;
}

export interface ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventAcceptSharedRollEntry';
  /** This is the barcode used for scanning the timeline event entry. */
  readonly barcode: Scalars['String'];
  /**
   * The moment the timeline event entry was created.
   * This is an ISO formatted timestamp, in UTC e.g. 2020-02-02T20:20:20.020Z
   */
  readonly createdAt: Scalars['String'];
  /** The associated event identifier for the timeline event entry. */
  readonly eventId: Scalars['String'];
  /** The reference identifier for the timeline event entry. */
  readonly referenceId: Scalars['String'];
}

export interface ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollsList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventAcceptSharedRollsList';
  /** The count of rolls which were accepted. */
  readonly count: Scalars['Int'];
  /** The list of rolls which were accepted. */
  readonly rolls: ReadonlyArray<Maybe<ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollEntry>>;
}

export interface ILoyaltyRollUpTheRimTimelineEventDetails {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventDetails';
  /** The optional redemption code for the timeline event entry. */
  readonly redemptionCode?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRollUpTheRimTimelineEventEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventEntry';
  /**
   * If present, this is the barcode used for scanning the timeline event entry.
   * Otherwise, this value is null.
   */
  readonly barcode?: Maybe<Scalars['String']>;
  /**
   * The moment the timeline event entry was created.
   * This is an ISO formatted timestamp, in UTC e.g. 2020-02-02T20:20:20.020Z
   */
  readonly createdAt: Scalars['String'];
  /** The details object containing optional fields for timeline events. */
  readonly details?: Maybe<ILoyaltyRollUpTheRimTimelineEventDetails>;
  /** The associated event identifier for the timeline event entry. */
  readonly eventId: Scalars['String'];
  /** The associated offer for the timeline event entry. */
  readonly offerStatus?: Maybe<ILoyaltyRollUpTheRimTimelineEventOfferStatus>;
  /**
   * If this timeline event entry is for a prize, this is the prize identifier.
   * Otherwise, this value is null.
   */
  readonly prizeId?: Maybe<Scalars['String']>;
  /** The optional redemption code for the timeline event entry. */
  readonly redemptionCode?: Maybe<Scalars['String']>;
  /**
   * The reference identifier for the timeline event entry.
   * Specify this value for revealing a roll.
   * Multiple events may occur for a given reference identity.
   * Only the most recent event for any reference identity is returned.
   */
  readonly referenceId: Scalars['String'];
  /** The unique identifier for the timeline event entry. */
  readonly timelineId: Scalars['String'];
  /** The type of timeline event entry. */
  readonly type: Scalars['String'];
}

export interface ILoyaltyRollUpTheRimTimelineEventList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventList';
  readonly count: Scalars['Int'];
  readonly events: ReadonlyArray<Maybe<ILoyaltyRollUpTheRimTimelineEventEntry>>;
  readonly resumeAfter?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRollUpTheRimTimelineEventOfferStatus {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventOfferStatus';
  /** The activation status of the associated offer */
  readonly activated?: Maybe<Scalars['Boolean']>;
  /** The associated offer identifier for the timeline event entry. */
  readonly offerId?: Maybe<Scalars['String']>;
  /** The status of the associated offer */
  readonly used?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyRollUpTheRimTimelineEventRollResult {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventRollResult';
  readonly code?: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly type: Scalars['String'];
}

export interface ILoyaltyRollUpTheRimTimelineEventShareRollResult {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventShareRollResult';
  /** The generated token which can be used to accept the shared rolls. */
  readonly token: Scalars['String'];
}

export interface ILoyaltyRollUpTheRimTimelineEventSharedRollTokenEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSharedRollTokenEntry';
  /** The count of shared rolls represented by the token. */
  readonly count: Scalars['Int'];
  /**
   * The token representing the number of shared rolls.
   * This can be used to accept the rolls by another user.
   */
  readonly token: Scalars['String'];
}

export interface ILoyaltyRollUpTheRimTimelineEventSharedRollTokenList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSharedRollTokenList';
  /** The count of tokens in the list. */
  readonly count: Scalars['Int'];
  /** The tokens representing shared rolls from the user's timeline events. */
  readonly tokens: ReadonlyArray<Maybe<ILoyaltyRollUpTheRimTimelineEventSharedRollTokenEntry>>;
}

export interface ILoyaltyRollUpTheRimTimelineEventSummaryEntry {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSummaryEntry';
  readonly count: Scalars['Int'];
  readonly eventId: Scalars['String'];
}

export interface ILoyaltyRollUpTheRimTimelineEventSummaryList {
  readonly __typename?: 'LoyaltyRollUpTheRimTimelineEventSummaryList';
  readonly count: Scalars['Int'];
  readonly events: ReadonlyArray<Maybe<ILoyaltyRollUpTheRimTimelineEventSummaryEntry>>;
  readonly resumeAfter?: Maybe<Scalars['String']>;
}

export interface ILoyaltyScanAndPay {
  readonly __typename?: 'LoyaltyScanAndPay';
  readonly scanAndPay?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyTransaction {
  readonly __typename?: 'LoyaltyTransaction';
  /** Bonus points earned. */
  readonly bonusPointsEarned: Scalars['Int'];
  readonly id: Scalars['String'];
  /** Points balance after this transaction. */
  readonly pointsBalance: Scalars['Int'];
  /** Points earned. */
  readonly pointsEarned: Scalars['Int'];
  /** Points used. */
  readonly pointsUsed: Scalars['Int'];
  /** Number of rewards used. */
  readonly rewardsUsed: Scalars['Int'];
}

export interface IMParticleEventAttributes {
  /**
   * User's device time in local time - 24 hr time
   * Example: 19:41:45
   */
  readonly device_time?: InputMaybe<Scalars['String']>;
  /** MParticle device ID */
  readonly mp_deviceid?: InputMaybe<Scalars['String']>;
}

export interface IMeInput {
  /** Should the unique items count extras added in the cart */
  readonly shouldIncludeExtras?: InputMaybe<Scalars['Boolean']>;
  /**
   * Should the unique items check for modifier differences
   * Example: Should a Medium Coffee with Cream and Sugar
   * be considered distinctly different from a
   * Medium Coffee with Cream and NO Sugar
   * Includes quantity as well.
   * Example: Medium Coffee with 1 Cream and 1 Sugar
   * is different than a Medium Coffee with 2 Cream and 1 Sugar
   */
  readonly shouldUniqueByModifiers?: InputMaybe<Scalars['Boolean']>;
}

export enum MediaType {
  CAROUSEL_ALBUM = 'CAROUSEL_ALBUM',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

/** A Prepaid Merge two gift cards response */
export interface IMerge {
  readonly __typename?: 'Merge';
  /** dollar amount destination gift card begins with */
  readonly beginBalance: Scalars['Int'];
  /** destination card currency code */
  readonly currencyCode: Scalars['String'];
  /** new balance of destination gift card after merge in dollars */
  readonly currentBalance: Scalars['Int'];
  /** card number of destination gift card */
  readonly destinationCardNumber: Scalars['String'];
  readonly fdAccountId?: Maybe<Scalars['String']>;
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  /** card number of source gift card that was deleted */
  readonly sourceCardNumber: Scalars['String'];
  readonly transactionId: Scalars['String'];
}

export interface IMissingItem {
  /** Line Id of item */
  readonly lineId: Scalars['String'];
  /** Quantity of items requested for refund */
  readonly refundQuantity: Scalars['Int'];
  /** Total quantity of items in a Combo or OfferCombo */
  readonly totalQuantity?: InputMaybe<Scalars['Int']>;
}

export interface IMissingOrderRefundDetails {
  readonly __typename?: 'MissingOrderRefundDetails';
  /** Amount refunded in cents */
  readonly approvedAmount: Scalars['Int'];
  /** Date time when refund was issued */
  readonly transactionDateTime: Scalars['String'];
}

export interface IMissingOrderResolution {
  readonly __typename?: 'MissingOrderResolution';
  /** Refund details */
  readonly refund?: Maybe<IMissingOrderRefundDetails>;
  /** Zendesk support ticket id */
  readonly ticket?: Maybe<Scalars['String']>;
}

export interface IMutation {
  readonly __typename?: 'Mutation';
  /**
   * @deprecated(reason: "TH specific")
   * Accepts the rolls represented by the shared rolls token specified.
   * The authenticated user is the user which accepts the shared rolls.
   */
  readonly acceptLoyaltyRollUpTheRimTimelineEventSharedRolls?: Maybe<ILoyaltyRollUpTheRimTimelineEventAcceptSharedRollsList>;
  /**
   * @deprecated(reason: "TH specific")
   * Activates a loyalty offer for a user.
   */
  readonly activateLoyaltyOffer?: Maybe<Scalars['Boolean']>;
  /**
   * @deprecated(reason: "Should use `payment service`.")
   * Add a Ayden or First Data account (credit card) for a customer.
   * Can throw MaxCreditCardsExistError.
   */
  readonly addCreditAccount: IAccount;
  /**
   * @deprecated(reason: "Should use `payment service`.")
   * Add a gift account (gift card) for a customer using a vaulted fd account.
   * Can throw MaxGiftCardsExistError.
   */
  readonly addGiftAccount: IGiftAccount;
  /** Gift an offer */
  readonly addGiftOfferByEmail: Scalars['Boolean'];
  /** Validate a gift token */
  readonly addOfferByToken: Scalars['Boolean'];
  /**
   * @deprecated(reason: "TH specific")
   * Activates a loyalty offer for a user.
   */
  readonly addVoucher?: Maybe<Scalars['Boolean']>;
  /** Assign one coupon token to the authenticated user id. */
  readonly assignCouponToken: ICouponToken;
  /** Attempt user login with OTP. */
  readonly attemptLoginOTP: IAttemptLoginOtpResponse;
  /**
   * @deprecated(reason: "TH specific")
   * Claim a prize in Roll Up the Rim.
   */
  readonly claimLoyaltyRollUpTheRimPrize?: Maybe<Scalars['Boolean']>;
  /**
   * Collect payments and commit the order to the PoS.
   *
   * If the service mode in the previously priced order was DRIVE_THRU or DELIVERY,
   * then the PoS will immediately start cooking the order. Else the PoS
   * will not cook the order until the customer arrives.
   *
   * (Please note that despite the name this is not a "transactional" flow)
   */
  readonly commitOrder: IOrder;
  /**
   * Store Member will choose wether to fulfill or accept the order at this point
   * Decline: will refund and send appropriate emails to user and store
   * Accept: will send a user and confirmation emails that the store will process
   * the order
   * @deprecated(reason: "Not needed anymore")
   */
  readonly confirmCateringOrder: IOrder;
  /** Create a favorite */
  readonly createFavorite: IFavorite;
  /** Request a jwt to auth for a given vendor */
  readonly createLoginForVendor?: Maybe<Scalars['String']>;
  /** Request a one-time password for the given user */
  readonly createLoginOTP: ICreateOtp;
  /** Create a loyalty user record associated with a given user */
  readonly createLoyaltyUser: IUser;
  /**
   * Request a one-time password for the given user
   * @deprecated Use createLoginOTP
   */
  readonly createOTP: ICreateOtp;
  /** Create a support case */
  readonly createSupportCase?: Maybe<ISupportCase>;
  /** Create user session with WLL Loyalty vendor */
  readonly createWllSession?: Maybe<IWllSession>;
  /** Delete a customer's account */
  readonly deleteAccount?: Maybe<Scalars['Boolean']>;
  /** Delete a favorite */
  readonly deleteFavorite: IFavorite;
  /**
   * @deprecated(reason: "TH specific")
   * Merges the existing loyalty card for a user into a new
   * loyalty card created at run time. This deletes the existing
   * loyalty card.
   */
  readonly deleteLoyaltyCard?: Maybe<ILoyaltyCard>;
  /** Delete current user */
  readonly deleteMe?: Maybe<Scalars['Boolean']>;
  /** Fetch public key & access token for encrypting CC values. */
  readonly encryptionDetails: IEncryptionDetails;
  /**
   * Validates a previously-created OTP code and then exchanges the
   * valid code for Cognito credentials
   */
  readonly exchangeOTPCodeForCognitoCredentials: ICognitoCredentials;
  readonly getAccountBalance: Scalars['Int'];
  readonly getCardNumber: Scalars['String'];
  readonly getEntitlementConsents: ReadonlyArray<Maybe<IEntitlementConsentListItem>>;
  readonly getEntitlementsMetaData: ReadonlyArray<Maybe<IEntitlementListItem>>;
  readonly getRenewedEntitlements: IEntitlementListItem;
  /**
   * @deprecated(reason: "TH specific")
   * Merges the physical cardId (existingCardId) into existingCardId for a user
   * This deletes the existing loyalty card.
   */
  readonly mergeLoyaltyCards?: Maybe<ILoyaltyCard>;
  /** Perform an account-binding authentication flow with the Payback API. */
  readonly paybackAuthentication: IPaybackSessionToken;
  /** Revoke user account binding from Payback. */
  readonly paybackDisconnectAccount?: Maybe<Scalars['Boolean']>;
  /** Logout a user from a Payback session. */
  readonly paybackLogout?: Maybe<Scalars['Boolean']>;
  /**
   * Collect payments and send emails to user and the store for further acknowledgement
   * and fulfillment of this order
   * @deprecated(reason: "Not needed anymore")
   */
  readonly placeCateringOrder: IOrder;
  /** Get balance for prepaid account */
  readonly prepaidsBalance: IBalance;
  /** Transfer balance of prepaid gift card into one and delete it */
  readonly prepaidsMerge: IMerge;
  /** Reload a prepaid gift card account */
  readonly prepaidsReload: IReload;
  /**
   * Price an order using the store's PoS.
   *
   * This endpoint _must_ be called previous to finalizing the order.
   */
  readonly priceOrder: IOrder;
  /** Redeem one coupon for the authenticated user id. */
  readonly redeemCoupon: ICoupon;
  /** Kicks off email with all data we have on the user */
  readonly requestMyInfo?: Maybe<Scalars['Boolean']>;
  /** Re-sends the current OTP code for the given user email/phone number */
  readonly resendCurrentLoginOTP: ICreateOtp;
  /** Re-sends the verification email to the current user */
  readonly resendVerificationEmail?: Maybe<Scalars['Boolean']>;
  /** Exchange previously stored BE Account Token for a new valid FE Session Token. */
  readonly revalidateSessionToken: IPaybackSessionToken;
  /**
   * @deprecated(reason: "TH specific")
   * Reveals the result of a timeline event roll.
   */
  readonly revealLoyaltyRollUpTheRimTimelineEventRoll?: Maybe<ILoyaltyRollUpTheRimTimelineEventRollResult>;
  /** Re-sends the verification email to the current user */
  readonly sendPhoneVerification?: Maybe<Scalars['Boolean']>;
  /** Send QR Scan Code to deep flame event */
  readonly sendQrSnapToDeepflame?: Maybe<Scalars['Boolean']>;
  /**
   * @deprecated(reason: "TH specific")
   * Set donation up charge for a loyalty user card
   */
  readonly setLoyaltyDonationUpcharge?: Maybe<ILoyaltyDonationUpcharge>;
  /**
   * @deprecated(reason: "TH specific")
   * Set reward tier for a loyalty user card
   */
  readonly setLoyaltyRewardsTier?: Maybe<ILoyaltyRewardsTier>;
  /**
   * @deprecated(reason: "TH specific")
   * Set scan and pay for a loyalty user card
   */
  readonly setLoyaltyScanAndPay?: Maybe<ILoyaltyScanAndPay>;
  /**
   * @deprecated(reason: "TH specific")
   * Set user's showThLoyaltyOnboarding property
   */
  readonly setShowThLoyaltyOnboarding?: Maybe<Scalars['Boolean']>;
  /**
   * @deprecated(reason: "TH specific")
   * Share quantity of Roll Up the Rim timeline event rolls.
   */
  readonly shareLoyaltyRollUpTheRimTimelineEventRolls?: Maybe<ILoyaltyRollUpTheRimTimelineEventShareRollResult>;
  /** Kicks off part one of Login Flow */
  readonly signInJWT?: Maybe<Scalars['Boolean']>;
  /** Sign up user with cognito returns a JWT */
  readonly signUp?: Maybe<Scalars['String']>;
  /** Update the entitlement consents to status 1 = grant or 2 = revoke. */
  readonly updateEntitlementConsents?: Maybe<Scalars['Boolean']>;
  /** Update a favorite */
  readonly updateFavorite: IFavorite;
  /** Update current user */
  readonly updateMe: IUser;
  /**
   * Update an order using the store's PoS.
   *
   * This endpoint _must_ be called after committing the order.
   */
  readonly updateOrder: IOrder;
  /**
   * User reports order or items in a order that are missing
   * @deprecated Use userRequestsRefund
   */
  readonly userReportsMissingOrder: IMissingOrderResolution;
  /** User requests a refund for an order or items that are missing or wrong. */
  readonly userRequestsRefund: IRefundRequestResponse;
  /** Validate the RBI generated JWT and exchange for cognito credentials */
  readonly validateAuthJwt: ICognitoCredentials;
  /** Runs all the validations required prior to order payment. */
  readonly validateCommitOrder?: Maybe<IOrder>;
  /** Verifies the phone number for the given user */
  readonly verifyPhoneNumber?: Maybe<Scalars['Boolean']>;
  /**
   * @deprecated(reason: "Should use `payment service`.")
   * Void a sale, issuing a full refund to the original payment method
   */
  readonly voidSale?: Maybe<ISale>;
}


export interface IMutationAcceptLoyaltyRollUpTheRimTimelineEventSharedRollsArgs {
  token: Scalars['String'];
}


export interface IMutationActivateLoyaltyOfferArgs {
  tokenId: Scalars['String'];
}


export interface IMutationAddCreditAccountArgs {
  input: IAddCreditAccountInput;
}


export interface IMutationAddGiftAccountArgs {
  input: IAddGiftAccountInput;
}


export interface IMutationAddGiftOfferByEmailArgs {
  input: IGiftOfferInput;
}


export interface IMutationAddOfferByTokenArgs {
  token: Scalars['String'];
}


export interface IMutationAddVoucherArgs {
  voucherId: Scalars['String'];
}


export interface IMutationAssignCouponTokenArgs {
  couponId: Scalars['ID'];
  expiresOn?: InputMaybe<Scalars['String']>;
  tokenId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IMutationAttemptLoginOtpArgs {
  input: ICreateOtpInput;
}


export interface IMutationClaimLoyaltyRollUpTheRimPrizeArgs {
  email: Scalars['String'];
  giftCardValueCents?: InputMaybe<Scalars['Int']>;
  isMajorPrize: Scalars['Boolean'];
  isTimHortonsGiftCard: Scalars['Boolean'];
  language: Scalars['String'];
  name: Scalars['String'];
  referenceId: Scalars['String'];
}


export interface IMutationCommitOrderArgs {
  delivery?: InputMaybe<ICommitDeliveryInput>;
  input: ICommitOrderInput;
  skipCoolingPeriod?: InputMaybe<Scalars['Boolean']>;
}


export interface IMutationConfirmCateringOrderArgs {
  input: IConfirmCateringOrderInput;
}


export interface IMutationCreateFavoriteArgs {
  input: IFavoriteInput;
}


export interface IMutationCreateLoginForVendorArgs {
  vendor: Scalars['String'];
}


export interface IMutationCreateLoginOtpArgs {
  input: ICreateOtpInput;
}


export interface IMutationCreateLoyaltyUserArgs {
  cognitoId: Scalars['String'];
}


export interface IMutationCreateOtpArgs {
  input: ICreateOtpInput;
}


export interface IMutationCreateSupportCaseArgs {
  caseInfo: ISupportCaseInput;
}


export interface IMutationDeleteAccountArgs {
  input: IDeleteAccountInput;
}


export interface IMutationDeleteFavoriteArgs {
  favoriteId: Scalars['String'];
}


export interface IMutationDeleteLoyaltyCardArgs {
  existingCardId: Scalars['String'];
}


export interface IMutationExchangeOtpCodeForCognitoCredentialsArgs {
  input: IExchangeOtpCodeForCredentialsInput;
}


export interface IMutationGetAccountBalanceArgs {
  sessionToken: Scalars['String'];
}


export interface IMutationGetCardNumberArgs {
  sessionToken: Scalars['String'];
}


export interface IMutationGetEntitlementConsentsArgs {
  sessionToken: Scalars['String'];
}


export interface IMutationGetEntitlementsMetaDataArgs {
  sessionToken: Scalars['String'];
}


export interface IMutationGetRenewedEntitlementsArgs {
  sessionToken: Scalars['String'];
}


export interface IMutationMergeLoyaltyCardsArgs {
  cardId: Scalars['String'];
  existingCardId: Scalars['String'];
}


export interface IMutationPaybackAuthenticationArgs {
  input: IPaybackAuthenticationInput;
}


export interface IMutationPaybackDisconnectAccountArgs {
  sessionToken: Scalars['String'];
}


export interface IMutationPaybackLogoutArgs {
  sessionToken: Scalars['String'];
}


export interface IMutationPlaceCateringOrderArgs {
  input: IPlaceCateringOrderInput;
}


export interface IMutationPrepaidsBalanceArgs {
  cardNumber: Scalars['String'];
  feCountryCode?: InputMaybe<IsoCountryCode>;
}


export interface IMutationPrepaidsMergeArgs {
  input: IPrepaidsMergeInput;
}


export interface IMutationPrepaidsReloadArgs {
  input: IPrepaidsReloadInput;
}


export interface IMutationPriceOrderArgs {
  delivery?: InputMaybe<IPriceDeliveryInput>;
  input: IPriceOrderInput;
}


export interface IMutationRedeemCouponArgs {
  couponId: Scalars['ID'];
}


export interface IMutationResendCurrentLoginOtpArgs {
  input: IResendOtpInput;
}


export interface IMutationResendVerificationEmailArgs {
  input: IResendVerificationEmailInput;
}


export interface IMutationRevealLoyaltyRollUpTheRimTimelineEventRollArgs {
  developmentPrize?: InputMaybe<Scalars['String']>;
  referenceId: Scalars['String'];
}


export interface IMutationSendPhoneVerificationArgs {
  input: IResendPhoneVerificationInput;
}


export interface IMutationSendQrSnapToDeepflameArgs {
  balances: ReadonlyArray<ILoyaltyBalance>;
  laneId: Scalars['String'];
  name: Scalars['String'];
  shortCode: Scalars['String'];
  storeId: Scalars['String'];
}


export interface IMutationSetLoyaltyDonationUpchargeArgs {
  cardId: Scalars['String'];
  donationUpcharge: Scalars['Boolean'];
}


export interface IMutationSetLoyaltyRewardsTierArgs {
  cardId: Scalars['String'];
  rewardsTier: Scalars['String'];
}


export interface IMutationSetLoyaltyScanAndPayArgs {
  cardId: Scalars['String'];
  defaultPaymentMethodId?: InputMaybe<Scalars['String']>;
  scanAndPay: Scalars['Boolean'];
}


export interface IMutationSetShowThLoyaltyOnboardingArgs {
  setShowThLoyaltyOnboarding: Scalars['Boolean'];
}


export interface IMutationShareLoyaltyRollUpTheRimTimelineEventRollsArgs {
  quantity: Scalars['Int'];
}


export interface IMutationSignInJwtArgs {
  userInfo: ISignInUserInput;
}


export interface IMutationSignUpArgs {
  userInfo: ISignUpUserInput;
}


export interface IMutationUpdateEntitlementConsentsArgs {
  input: IPaybackUpdateEntitlementConsentsInput;
}


export interface IMutationUpdateFavoriteArgs {
  favoriteId: Scalars['String'];
  input: IFavoriteInput;
}


export interface IMutationUpdateMeArgs {
  details: IUpdateUserDetailsInput;
}


export interface IMutationUpdateOrderArgs {
  input: IUpdateOrderInput;
}


export interface IMutationUserReportsMissingOrderArgs {
  input: IUserReportsMissingOrderInput;
}


export interface IMutationUserRequestsRefundArgs {
  input: IUserRequestsRefundInput;
}


export interface IMutationValidateAuthJwtArgs {
  authInput: IValidateAuthJwtInput;
}


export interface IMutationValidateCommitOrderArgs {
  input: IValidateCommitOrderInput;
}


export interface IMutationVerifyPhoneNumberArgs {
  input: IVerifyPhoneNumberInput;
}


export interface IMutationVoidSaleArgs {
  fdSaleId: Scalars['String'];
}

/**
 * https://relay.dev/graphql/connections.htm#sec-Node
 *
 * Interface that is implemented by an application data node.
 */
export interface INode {
  readonly id?: Maybe<Scalars['ID']>;
}

export enum OfferType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface IOfferVariable {
  readonly __typename?: 'OfferVariable';
  /** The key of OfferVariable. */
  readonly key: Scalars['String'];
  /**
   * The type of OfferVariable to be used by FE. Available types:
   * 'currency',
   * 'datetime',
   * 'int',
   * 'number',
   * 'string',
   */
  readonly type: Scalars['String'];
  /** The value of OfferVariable. */
  readonly value: Scalars['String'];
}

/**
 * Operating hours for a restaurant in local time formatted
 * as "YYYY-MM-DD hh:mm:ss" (the date component should be ignored)
 */
export interface IOperatingHours {
  readonly __typename?: 'OperatingHours';
  /** Friday operating hours close */
  readonly friClose?: Maybe<Scalars['String']>;
  /** Friday operating hours open */
  readonly friOpen?: Maybe<Scalars['String']>;
  /** Monday operating hours close */
  readonly monClose?: Maybe<Scalars['String']>;
  /** Monday operating hours open */
  readonly monOpen?: Maybe<Scalars['String']>;
  /** Saturday operating hours close */
  readonly satClose?: Maybe<Scalars['String']>;
  /** Saturday operating hours open */
  readonly satOpen?: Maybe<Scalars['String']>;
  /** Sunday operating hours close */
  readonly sunClose?: Maybe<Scalars['String']>;
  /** Sunday operating hours open */
  readonly sunOpen?: Maybe<Scalars['String']>;
  /** Thursday operating hours close */
  readonly thrClose?: Maybe<Scalars['String']>;
  /** Thursday operating hours open */
  readonly thrOpen?: Maybe<Scalars['String']>;
  /** Tuesday operating hours close */
  readonly tueClose?: Maybe<Scalars['String']>;
  /** Tuesday operating hours open */
  readonly tueOpen?: Maybe<Scalars['String']>;
  /** Wednesday operating hours close */
  readonly wedClose?: Maybe<Scalars['String']>;
  /** Wednesday operating hours open */
  readonly wedOpen?: Maybe<Scalars['String']>;
}

export enum OperationalStatus {
  CLOSED = 'CLOSED',
  CLOSED_TEMPORARILY = 'CLOSED_TEMPORARILY',
  OPEN = 'OPEN',
  PROJECTED = 'PROJECTED'
}

export interface IOrbitalPayment {
  /**
   * Represents a saved funding source. (i.e. orbitalIdentifier or recurringDetailReference)
   * If passed this will be used to process payment. Either accountIdentifier or
   * encrypted payload is required.
   */
  readonly accountIdentifier?: InputMaybe<Scalars['String']>;
  /** Encrypted Payment Payload. If accountIdentifier is not passed this will be used. */
  readonly encryptedPayload?: InputMaybe<IAddOrbitalAccountInput>;
  /** When true, payment details will be saved as a recurring payment method in Adyen */
  readonly savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
}

export interface IOrder {
  readonly __typename?: 'Order';
  readonly cart: ICart;
  readonly catering?: Maybe<ICatering>;
  readonly createdAt: Scalars['String'];
  readonly delivery?: Maybe<IDelivery>;
  readonly earliestPickupTimeInSeconds?: Maybe<Scalars['String']>;
  readonly fireOrderIn?: Maybe<Scalars['Int']>;
  readonly fulfillmentDetails?: Maybe<IFulfillmentDetails>;
  /** Same value as rbiOrderId, used for Apollo Cache */
  readonly id?: Maybe<Scalars['String']>;
  readonly loyaltyTransaction?: Maybe<ILoyaltyTransaction>;
  readonly order?: Maybe<IRbiOrder>;
  readonly orderNumberFormatted?: Maybe<Scalars['String']>;
  readonly pk: Scalars['String'];
  readonly posOrderId?: Maybe<Scalars['String']>;
  readonly posVendor: PosVendor;
  readonly rbiOrderId: Scalars['String'];
  readonly revision: Scalars['Int'];
  readonly sk: Scalars['String'];
  readonly status: RbiOrderStatus;
  readonly updatedAt: Scalars['String'];
  readonly userId?: Maybe<Scalars['String']>;
  readonly userSortKey: Scalars['String'];
}

export interface IOrderListResponse {
  readonly __typename?: 'OrderListResponse';
  readonly count: Scalars['Int'];
  readonly orders?: Maybe<ReadonlyArray<Maybe<IOrder>>>;
  readonly resumeAfter?: Maybe<Scalars['String']>;
}

export enum OrderingStatus {
  ALPHA = 'alpha',
  BETA = 'beta',
  DEV = 'dev',
  LIVE = 'live',
  PROD = 'prod',
  TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable',
  TEMPORARY_UNAVAILABLE = 'temporary_unavailable'
}

/**
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 *
 * Page information to determine if there are more results, and what node,
 * determined by it's cursor, is at the start and end of the page returned.
 */
export interface IPageInfo {
  readonly __typename?: 'PageInfo';
  readonly endCursor?: Maybe<Scalars['String']>;
  readonly hasNextPage: Scalars['Boolean'];
  readonly hasPreviousPage: Scalars['Boolean'];
  readonly startCursor?: Maybe<Scalars['String']>;
}

export interface IParentChildPlu {
  readonly __typename?: 'ParentChildPlu';
  readonly childPlu?: Maybe<Scalars['String']>;
  readonly plu?: Maybe<Scalars['String']>;
}

export interface IParentChildPluInput {
  readonly childPlu?: InputMaybe<Scalars['String']>;
  readonly plu?: InputMaybe<Scalars['String']>;
}

export interface IPaybackAccountToken {
  readonly __typename?: 'PaybackAccountToken';
  /** A long-lived token (6 mo.) that is used to identify the user to the back-end consumer. */
  readonly accountToken: Scalars['String'];
}

export interface IPaybackAuthenticationInput {
  /** A short-lived code that is tied to the front-end consumer. */
  readonly authorizationCode: Scalars['String'];
  /**
   * The redirect URI provided to the front-end consumer when initiating the login flow.
   * This does not affect any redirects that occur after the login flow, but the field
   * if required by the consumers when initiating the flow from Payback's website.
   */
  readonly redirectURI: Scalars['String'];
}

export interface IPaybackSessionToken {
  readonly __typename?: 'PaybackSessionToken';
  /** Unique Payback User ID */
  readonly paybackUserId: Scalars['String'];
  /** A short-lived token (30 min.) that is used to identify the user to the front-end consumer. */
  readonly sessionToken: Scalars['String'];
}

export interface IPaybackUpdateEntitlementConsentsInput {
  /** The entitlement short name of the entitlement consent to be updated (eg.: OIMIKI_BK1) */
  readonly entitlementShortName: Scalars['String'];
  /** User's Session token */
  readonly sessionToken: Scalars['String'];
  /** The consent status (1 = grant, 2 = revoke) of the entitlement consent to be updated */
  readonly status: Scalars['String'];
}

export interface IPayment {
  readonly __typename?: 'Payment';
  readonly approvalNumber?: Maybe<Scalars['String']>;
  readonly cardType?: Maybe<Scalars['String']>;
  readonly ccLast4?: Maybe<Scalars['String']>;
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  readonly fdSaleId: Scalars['String'];
  readonly panToken?: Maybe<Scalars['String']>;
  readonly paymentType?: Maybe<CartPaymentType>;
}

export interface IPaymentInput {
  /** Details from Apple Pay for payment. */
  readonly applePayDetails?: InputMaybe<IApplePay>;
  /** Billing address associated to card */
  readonly billingAddress?: InputMaybe<IBillingAddressInput>;
  /** Denotes a cash payment */
  readonly cashPayment?: InputMaybe<Scalars['Boolean']>;
  /** Contains supplemental data for CC transactions */
  readonly ccMetadata?: InputMaybe<ICreditCardMetadataInput>;
  /** First Data payment data */
  readonly firstDataInput?: InputMaybe<IFirstDataPayment>;
  /** Name on credit card */
  readonly fullName: Scalars['String'];
  /** Details from Google Pay for payment. */
  readonly googlePayDetails?: InputMaybe<IGooglePay>;
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   */
  readonly kountSessionId?: InputMaybe<Scalars['String']>;
  /** Orbital Payment data */
  readonly orbitalInput?: InputMaybe<IOrbitalPayment>;
}

export interface IPaymentMethodData {
  /** Card display name with last 4 digits of the credit card */
  readonly displayName?: InputMaybe<Scalars['String']>;
  /** Card type used for digital pay */
  readonly paymentMethodType?: InputMaybe<Scalars['String']>;
  /** Payment type used for digital pay */
  readonly paymentType?: InputMaybe<Scalars['String']>;
}

export enum PaymentProcessor {
  ADYEN = 'ADYEN',
  FIRSTDATA = 'FIRSTDATA',
  ORBITAL = 'ORBITAL'
}

export interface IPhysicalAddress {
  readonly __typename?: 'PhysicalAddress';
  readonly address1?: Maybe<Scalars['String']>;
  readonly address2?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly stateProvince?: Maybe<Scalars['String']>;
  readonly stateProvinceShort?: Maybe<Scalars['String']>;
}

export interface IPlaceCateringOrderInput {
  /**
   * Billing address Comes in the following format
   * billingStreetAddress, billingApt, billingCity, billingState, billingZip
   */
  readonly billingAddress?: InputMaybe<IBillingAddressInput>;
  /**
   * Catering Information
   * contains Datetime for the catering
   */
  readonly cateringInfo: ICateringInfoInput;
  /**
   * First 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{6}$")
   */
  readonly ccBin?: InputMaybe<Scalars['String']>;
  /** Credit card 2 digit expiry month */
  readonly ccExpiryMonth?: InputMaybe<Scalars['String']>;
  /** Credit card 2 digit expiry year */
  readonly ccExpiryYear?: InputMaybe<Scalars['String']>;
  /**
   * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{4}$")
   */
  readonly ccLast4?: InputMaybe<Scalars['String']>;
  /** The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX) */
  readonly creditType?: InputMaybe<CartPaymentCardType>;
  /** Valid access token for accessing First Data API */
  readonly fdAccessToken?: InputMaybe<Scalars['String']>;
  /**
   * The First Data payment method ID which must be associated to the user
   * making the request.
   */
  readonly fdAccountId?: InputMaybe<Scalars['String']>;
  /**
   * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce.
   */
  readonly fdNonce?: InputMaybe<Scalars['String']>;
  /** Customer full name */
  readonly fullName?: InputMaybe<Scalars['String']>;
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   */
  readonly kountSessionId?: InputMaybe<Scalars['String']>;
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['ID'];
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: InputMaybe<Scalars['String']>;
  /**
   * Unique Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   *
   * Note that the "sessionId" field is deprecated and will be ignored.
   */
  readonly sessionId?: InputMaybe<Scalars['String']>;
  /** Store email address */
  readonly storeEmail?: InputMaybe<Scalars['String']>;
  /** Details from 3DS transactions, relates to properties needed to resume sale transactions. */
  readonly threeDSDetails?: InputMaybe<IResumeThreeDSaleTransaction>;
}

export { Platform };

export interface IPlu {
  readonly __typename?: 'Plu';
  readonly brink?: Maybe<Scalars['String']>;
  readonly brinkDelivery?: Maybe<Scalars['String']>;
  readonly connector?: Maybe<Scalars['String']>;
  readonly ncr?: Maybe<Scalars['String']>;
  readonly ncrDelivery?: Maybe<Scalars['String']>;
  readonly oheics?: Maybe<Scalars['String']>;
  readonly oheicsDelivery?: Maybe<Scalars['String']>;
  readonly partner?: Maybe<Scalars['String']>;
  readonly partnerDelivery?: Maybe<Scalars['String']>;
  readonly productNumber?: Maybe<Scalars['String']>;
  readonly productNumberDelivery?: Maybe<Scalars['String']>;
  readonly qst?: Maybe<Scalars['String']>;
  readonly qstDelivery?: Maybe<Scalars['String']>;
  readonly sicom?: Maybe<Scalars['String']>;
  readonly sicomDelivery?: Maybe<Scalars['String']>;
  readonly simphony?: Maybe<Scalars['String']>;
  readonly simphonyDelivery?: Maybe<Scalars['String']>;
  readonly simplyDelivery?: Maybe<Scalars['String']>;
  readonly simplyDeliveryDelivery?: Maybe<Scalars['String']>;
}

export interface IPluData {
  readonly __typename?: 'PluData';
  readonly deliveryPlus?: Maybe<Scalars['String']>;
  readonly plus?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['String']>;
}

export interface IPluInput {
  readonly brink?: InputMaybe<Scalars['String']>;
  readonly brinkDelivery?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly connector?: InputMaybe<Scalars['String']>;
  readonly ncr?: InputMaybe<Scalars['String']>;
  readonly ncrDelivery?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly oheics?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly oheicsDelivery?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly partner?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly partnerDelivery?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly productNumber?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly qst?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly qstDelivery?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly rpos?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly rposDelivery?: InputMaybe<Scalars['String']>;
  readonly sicom?: InputMaybe<Scalars['String']>;
  readonly sicomDelivery?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly simphony?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly simphonyDelivery?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly simplyDelivery?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly simplyDeliveryDelivery?: InputMaybe<Scalars['String']>;
}

export enum PosVendor {
  BRINK = 'BRINK',
  CARROLS = 'CARROLS',
  /** @deprecated POS no longer in use */
  CONNECTOR = 'CONNECTOR',
  NCR = 'NCR',
  /** @deprecated POS no longer in use */
  OHEICS = 'OHEICS',
  /** @deprecated POS no longer in use */
  PARTNER = 'PARTNER',
  /** @deprecated POS no longer in use */
  PRODUCT_NUMBER = 'PRODUCT_NUMBER',
  QDI = 'QDI',
  /** @deprecated POS no longer in use */
  QST = 'QST',
  /** @deprecated POS no longer in use */
  RPOS = 'RPOS',
  SICOM = 'SICOM',
  /** @deprecated POS no longer in use */
  SIMPHONY = 'SIMPHONY',
  /** @deprecated POS no longer in use */
  SIMPLY_DELIVERY = 'SIMPLY_DELIVERY',
  /** @deprecated POS no longer in use */
  TABLET = 'TABLET'
}

/** A transaction for a prepaid gift card */
export interface IPrepaidTransaction {
  readonly __typename?: 'PrepaidTransaction';
  /** First Data account ID */
  readonly amount: Scalars['Int'];
  readonly currencyCode: ICurrencyCode;
  readonly info: Scalars['String'];
  readonly transactionTime: Scalars['String'];
}

/** Merge two prepaid gift cards into one. Source gets deleted. */
export interface IPrepaidsMergeInput {
  /** Destination first data gift card Account ID gets balance from source */
  readonly destinationFdAccountId?: InputMaybe<Scalars['String']>;
  /** Number of physical Gift Card which is the funding source (card being deactivated) */
  readonly sourceCardNumber: Scalars['String'];
  /** Pin number for physical gift card which is the funding source (card being deactivated) */
  readonly sourcePin?: InputMaybe<Scalars['String']>;
}

/** Reload a prepaid gift card (payment method) */
export interface IPrepaidsReloadInput {
  /**
   * Details from Apple Pay for funding. Only one of fdAccountId or
   * applePayDetails or googlePayDetails should be provided.
   */
  readonly applePayDetails?: InputMaybe<IApplePay>;
  /** Country of currency to reload card */
  readonly countryCode?: InputMaybe<CountryCode>;
  /**
   * Vaulted first data Account ID (credit) used to fund gift card.
   * Either this or applePayDetails is required.
   * Only one of fdAccountId or
   * applePayDetails or googlePayDetails should be provided.
   */
  readonly fdAccountId?: InputMaybe<Scalars['String']>;
  /** Amount to fund to gift card account in cents */
  readonly fundValue: Scalars['Int'];
  /**
   * Details from Goole Pay for funding. Only one of fdAccountId or
   * applePayDetails or googlePayDetails should be provided.
   */
  readonly googlePayDetails?: InputMaybe<IGooglePay>;
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   */
  readonly kountSessionId?: InputMaybe<Scalars['String']>;
  /** First Data Account ID of prepaid gift card to be reloaded */
  readonly prepaidFdAccountId: Scalars['String'];
  /**
   * Session ID as set by the FE.
   *
   * Note that the "sessionId" field is deprecated and will be ignored.
   */
  readonly sessionId?: InputMaybe<Scalars['String']>;
}

export interface IPriceDeliveryInput {
  readonly dropoff: IDeliveryWaypointInput;
  readonly instructions?: InputMaybe<Scalars['String']>;
  readonly quoteId?: InputMaybe<Scalars['String']>;
  readonly tipCents?: InputMaybe<Scalars['Int']>;
}

export interface IPriceOrderInput {
  /** Offers applied to cart */
  readonly appliedOffers?: InputMaybe<ReadonlyArray<InputMaybe<IAppliedOffer>>>;
  /** The brand of the store. */
  readonly brand: Brand;
  /** The order cart entries to be injected into the POS. */
  readonly cartEntries?: InputMaybe<ReadonlyArray<ICartEntryInput>>;
  /** The cart shape version. */
  readonly cartVersion?: InputMaybe<Scalars['Int']>;
  /** The locale of the customer. */
  readonly customerLocale?: InputMaybe<Scalars['String']>;
  /**
   * The name of the customer. If provided, this will
   * supersede the user's name on this order.
   */
  readonly customerName?: InputMaybe<Scalars['String']>;
  /** barcode of user's loyalty card to apply reward/visit */
  readonly loyaltyBarcode?: InputMaybe<Scalars['String']>;
  /** payment method - for cash orders */
  readonly paymentMethod?: InputMaybe<CartPaymentCardType>;
  /** The Platform */
  readonly platform?: InputMaybe<Platform>;
  /** The POS Vendor */
  readonly posVendor: PosVendor;
  /** quoteId associated to */
  readonly quotedId?: InputMaybe<Scalars['String']>;
  /** flag for reward redemption, if true must provide loyaltyBarcode */
  readonly redeemReward?: InputMaybe<Scalars['Boolean']>;
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: InputMaybe<Scalars['String']>;
  /** Requested sale amount in cents (USD) */
  readonly requestedAmountCents: Scalars['Int'];
  /** Reward ids being applied to cart */
  readonly rewardsApplied?: InputMaybe<ReadonlyArray<InputMaybe<IAppliedReward>>>;
  /** How the order will be executed. */
  readonly serviceMode: ServiceMode;
  /** Store Address, derived from MDM. */
  readonly storeAddress: IStoreAddressInput;
  /** Store ID, derived from MDM. This value will be validated within First Data. */
  readonly storeId: Scalars['String'];
  /** The internal Store ID. */
  readonly storePosId?: InputMaybe<Scalars['String']>;
  /**
   * Cart Item swaps being applied to cart
   * @deprecated(reason: "Not needed anymore since it is included in AppliedOffer")
   */
  readonly swaps?: InputMaybe<ReadonlyArray<InputMaybe<ISwapInput>>>;
  /** vat number on the restaurant document for BK UK */
  readonly vatNumber?: InputMaybe<Scalars['String']>;
}

export interface IProductDetailInput {
  readonly id?: InputMaybe<Scalars['String']>;
  readonly quantity?: InputMaybe<Scalars['Int']>;
  readonly sublevelItems?: InputMaybe<ReadonlyArray<InputMaybe<IItem>>>;
}

export interface IProductHierarchyInput {
  readonly L1?: InputMaybe<Scalars['String']>;
  readonly L2?: InputMaybe<Scalars['String']>;
  readonly L3?: InputMaybe<Scalars['String']>;
  readonly L4?: InputMaybe<Scalars['String']>;
  readonly L5?: InputMaybe<Scalars['String']>;
}

export interface IQuantityPlu {
  readonly __typename?: 'QuantityPlu';
  readonly plu?: Maybe<Scalars['String']>;
  readonly qualifier?: Maybe<Scalars['String']>;
  readonly quantity?: Maybe<Scalars['Int']>;
}

export interface IQuantityPluInput {
  readonly plu?: InputMaybe<Scalars['String']>;
  readonly qualifier?: InputMaybe<Scalars['String']>;
  readonly quantity?: InputMaybe<Scalars['Int']>;
}

export interface IQuery {
  readonly __typename?: 'Query';
  /** API Metadata */
  readonly api?: Maybe<IApiMetadata>;
  /**
   * Query an order by providing a catering JWT for the current order
   * @deprecated(reason: "Not needed anymore")
   */
  readonly cateringOrder?: Maybe<IOrder>;
  /**
   * Query if customer initiated refunds is enabled for an order.
   * @deprecated(reason: "Should use fulfillment instead")
   */
  readonly checkRefundEligibility?: Maybe<IRefundEligibilityResponse>;
  /** Obtain a quote to deliver an order. */
  readonly deliveryQuote: IDelivery;
  /** Returns an available delivery restaurant based on vendor quote given provided address and search radius. */
  readonly deliveryRestaurant: IDeliveryRestaurant;
  /**
   * Evaluate all couponIds from sanity. All cart-dependent rules are bypassed.
   * If authenticated, offers will evaluated in the context of the authenticated user id.
   */
  readonly evaluateAllUserOffers: ICouponUserOffersFeedback;
  /**
   * Evaluate user offers: either those in the cart or a set to be evaluated against one.
   * If no cart and no RBI order are specified, then all cart-dependent rules are bypassed.
   * If authenticated, offers will evaluated in the context of the authenticated user id.
   * Setting the evaluateAllCouponIds flag will ignore couponIds and evaluate all couponIds from sanity.
   */
  readonly evaluateUserOffers: ICouponUserOffersFeedback;
  /** Get a specific coupon for the authenticated user id. */
  readonly getCoupon?: Maybe<ICoupon>;
  /** Get instagram feed image urls. Input is number of images to be fetched */
  readonly getImageFeed: ReadonlyArray<IInstagramImage>;
  /**
   * @deprecated(reason: "TH specific")
   * Gets a base64 encoded Apple Pass for a loyalty card
   */
  readonly getLoyaltyCardApplePass?: Maybe<ILoyaltyCardApplePass>;
  /**
   * @deprecated(reason: "TH specific")
   * Get the details for a user's loyalty card
   */
  readonly getLoyaltyCardDetails?: Maybe<ILoyaltyCardDetails>;
  /**
   * @deprecated(reason: "TH specific")
   * Get the details for a user's loyalty card via barcode *UNAUTHENTICATED*
   */
  readonly getLoyaltyCardDetailsKiosk?: Maybe<ILoyaltyCardDetailsKiosk>;
  /**
   * @deprecated(reason: "TH specific")
   * Gets a jwt for Google Pass for a loyalty card
   */
  readonly getLoyaltyCardGooglePass?: Maybe<ILoyaltyCardGooglePass>;
  /**
   * @deprecated(reason: "TH specific")
   * Get the transactions for a user's loyalty card
   */
  readonly getLoyaltyCardTransactions?: Maybe<ILoyaltyCardTransactions>;
  /**
   * @deprecated(reason: "TH specific")
   * Get the loyalty cards for a user. @todo put this on me
   */
  readonly getLoyaltyCards?: Maybe<ILoyaltyCardsResp>;
  /**
   * @deprecated(reason: "TH specific")
   * Get the loyalty cards for a user with metadata.
   * Also syncs loyaltyTier between THD & CTG
   */
  readonly getLoyaltyCardsWithDetails?: Maybe<ILoyaltyCardsWithDetailsResp>;
  /**
   * @deprecated(reason: "TH specific")
   * Get the Roll Up The Rim prizes stats
   */
  readonly getLoyaltyRollUpTheRimPrizesStats?: Maybe<ILoyaltyRollUpTheRimPrizesStats>;
  /**
   * @deprecated(reason: "TH specific")
   * Get the list of tokens representing shared rolls from a user's event timeline.
   */
  readonly getLoyaltyRollUpTheRimTimelineEventSharedRollTokens?: Maybe<ILoyaltyRollUpTheRimTimelineEventSharedRollTokenList>;
  /**
   * @deprecated(reason: "TH specific")
   * Get the Roll Up The Rim timeline events, summarized for a user
   */
  readonly getLoyaltyRollUpTheRimTimelineEventSummary?: Maybe<ILoyaltyRollUpTheRimTimelineEventSummaryList>;
  /**
   * @deprecated(reason: "TH specific")
   * Get the Roll Up The Rim timeline events for a user
   */
  readonly getLoyaltyRollUpTheRimTimelineEvents?: Maybe<ILoyaltyRollUpTheRimTimelineEventList>;
  /** Evaluate the redemption eligibility of a coupon for the authenticated user id. */
  readonly isCouponRedeemable: ICouponRedemptionEligibility;
  /** Query all coupon tokens by coupon and the authenticated user id. */
  readonly listCouponTokens: ICouponTokenListResponse;
  /** Query all coupons for the authenticated user id. */
  readonly listCoupons: ICouponListResponse;
  /** Query all gift offers. */
  readonly listGiftOffers?: Maybe<IGiftOfferListResponse>;
  /** Query all deep flame recommendations */
  readonly listRecommendationItems?: Maybe<IRecommendationItemResult>;
  readonly listUserCouponTokens: ICouponTokenListResponse;
  readonly me: IUser;
  /** Query an order by order id for the current user. */
  readonly order?: Maybe<IOrder>;
  /** Query an order's history by order id */
  readonly orderRevisions: IOrderListResponse;
  readonly pluData?: Maybe<IPluData>;
  /**
   * @deprecated(reason: "Should use `payment service`.")
   * Return transaction history for prepaid gift card account from FD
   */
  readonly prepaidsTransactions?: Maybe<ITransactionListResponse>;
  /** Returns a restaurant entity given store id */
  readonly restaurant: IRestaurant;
  /**
   * Returns a list of restaurants based on provided filters.
   * @todo: Return result with pagination metadata
   */
  readonly restaurants?: Maybe<IRestaurantsConnection>;
  /** Check if the registration is complete */
  readonly signUpComplete?: Maybe<Scalars['Boolean']>;
  /** Query orders from unique stores for current user. */
  readonly uniqueStores: IOrderListResponse;
  /**
   * @deprecated(reason: "Should use `payment service`.")
   * Fetch all accounts for current customer (limit 100)
   */
  readonly userAccounts?: Maybe<IAccountListResponse>;
  /** Get a user favorite */
  readonly userFavorite: IFavorite;
  /** List of user favorites */
  readonly userFavorites: IFavoriteList;
  readonly userGeo: IUserGeo;
  /**
   * Query all orders for current user.
   *
   * Note that the "userId" field is deprecated and will be ignored.
   */
  readonly userOrders: IOrderListResponse;
  /** Get user phone from braze */
  readonly userPhoneFromBraze?: Maybe<IBrazeUserPhone>;
}


export interface IQueryCateringOrderArgs {
  cateringJwt: Scalars['String'];
}


export interface IQueryCheckRefundEligibilityArgs {
  rbiOrderId: Scalars['ID'];
}


export interface IQueryDeliveryQuoteArgs {
  dropoff: IDeliveryWaypointInput;
  pickup: IDeliveryWaypointInput;
  requestedAmountCents?: InputMaybe<Scalars['Int']>;
  serviceMode?: InputMaybe<ServiceMode>;
}


export interface IQueryDeliveryRestaurantArgs {
  dropoff: IDeliveryWaypointInput;
  platform?: InputMaybe<Platform>;
  searchRadius: Scalars['Float'];
}


export interface IQueryEvaluateAllUserOffersArgs {
  locale?: InputMaybe<Locale>;
  platform?: InputMaybe<Platform>;
  redeemedOn: Scalars['String'];
  serviceMode?: InputMaybe<ServiceMode>;
  storeId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryEvaluateUserOffersArgs {
  cart?: InputMaybe<IPriceOrderInput>;
  couponIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  evaluateAllCouponIds?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Locale>;
  platform?: InputMaybe<Platform>;
  rbiOrderId?: InputMaybe<Scalars['ID']>;
  redeemedOn: Scalars['String'];
  serviceMode?: InputMaybe<ServiceMode>;
  storeId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryGetCouponArgs {
  couponId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryGetImageFeedArgs {
  input?: InputMaybe<Scalars['Int']>;
}


export interface IQueryGetLoyaltyCardApplePassArgs {
  cardId: Scalars['String'];
}


export interface IQueryGetLoyaltyCardDetailsArgs {
  cardId: Scalars['String'];
}


export interface IQueryGetLoyaltyCardDetailsKioskArgs {
  barcode: Scalars['String'];
  operator: Scalars['String'];
  restaurantId: Scalars['String'];
  terminal: Scalars['String'];
  transactionId: Scalars['String'];
}


export interface IQueryGetLoyaltyCardGooglePassArgs {
  cardId: Scalars['String'];
}


export interface IQueryGetLoyaltyCardTransactionsArgs {
  cardId: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
}


export interface IQueryGetLoyaltyCardsArgs {
  status?: InputMaybe<Scalars['String']>;
}


export interface IQueryGetLoyaltyCardsWithDetailsArgs {
  status?: InputMaybe<Scalars['String']>;
}


export interface IQueryGetLoyaltyRollUpTheRimPrizesStatsArgs {
  eventId?: InputMaybe<Scalars['String']>;
}


export interface IQueryGetLoyaltyRollUpTheRimTimelineEventSummaryArgs {
  eventId?: InputMaybe<Scalars['String']>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
}


export interface IQueryGetLoyaltyRollUpTheRimTimelineEventsArgs {
  eventId?: InputMaybe<Scalars['String']>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
}


export interface IQueryIsCouponRedeemableArgs {
  cart?: InputMaybe<IPriceOrderInput>;
  couponId: Scalars['ID'];
  rbiOrderId?: InputMaybe<Scalars['ID']>;
  redeemedOn: Scalars['String'];
  ruleSet?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryListCouponTokensArgs {
  couponId: Scalars['ID'];
  expiresAfter?: InputMaybe<Scalars['String']>;
  expiresBefore?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryListCouponsArgs {
  expiresAfter?: InputMaybe<Scalars['String']>;
  expiresBefore?: InputMaybe<Scalars['String']>;
  includeRedeemed?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryListRecommendationItemsArgs {
  productDetails: ReadonlyArray<InputMaybe<IProductDetailInput>>;
  serviceMode: ServiceMode;
  storeId: Scalars['String'];
  type: RecommendationType;
}


export interface IQueryListUserCouponTokensArgs {
  couponId?: InputMaybe<Scalars['ID']>;
  expiresAfter?: InputMaybe<Scalars['String']>;
  expiresBefore?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryMeArgs {
  customInput?: InputMaybe<IMeInput>;
  numUniquePurchasedItems?: InputMaybe<Scalars['Int']>;
}


export interface IQueryOrderArgs {
  mParticleEventAttributes?: InputMaybe<IMParticleEventAttributes>;
  rbiOrderId: Scalars['ID'];
}


export interface IQueryOrderRevisionsArgs {
  limit?: InputMaybe<Scalars['Int']>;
  rbiOrderId: Scalars['ID'];
  resumeAfter?: InputMaybe<Scalars['String']>;
  revision?: InputMaybe<Scalars['String']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
}


export interface IQueryPluDataArgs {
  storeId: Scalars['String'];
}


export interface IQueryPrepaidsTransactionsArgs {
  cardNumber?: InputMaybe<Scalars['String']>;
  fdAccountId?: InputMaybe<Scalars['String']>;
}


export interface IQueryRestaurantArgs {
  localDateTime?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['String']>;
  storeNumber?: InputMaybe<Scalars['String']>;
}


export interface IQueryRestaurantsArgs {
  input?: InputMaybe<IRestaurantsInput>;
}


export interface IQuerySignUpCompleteArgs {
  jwt: Scalars['String'];
}


export interface IQueryUniqueStoresArgs {
  createdAfter?: InputMaybe<Scalars['String']>;
  createdBefore?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderStatuses?: InputMaybe<ReadonlyArray<RbiOrderStatus>>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
}


export interface IQueryUserAccountsArgs {
  feCountryCode?: InputMaybe<IsoCountryCode>;
}


export interface IQueryUserFavoriteArgs {
  favoriteId: Scalars['String'];
}


export interface IQueryUserFavoritesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
}


export interface IQueryUserOrdersArgs {
  createdAfter?: InputMaybe<Scalars['String']>;
  createdBefore?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderStatuses?: InputMaybe<ReadonlyArray<RbiOrderStatus>>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  shouldFilterByRegion?: InputMaybe<Scalars['Boolean']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryUserPhoneFromBrazeArgs {
  brazeId?: InputMaybe<Scalars['String']>;
}

export interface IRbiOrder {
  readonly __typename?: 'RbiOrder';
  readonly refund?: Maybe<IRefund>;
}

export enum RbiOrderStatus {
  CATERING_DECLINED = 'CATERING_DECLINED',
  CATERING_ERROR = 'CATERING_ERROR',
  CATERING_PLACED = 'CATERING_PLACED',
  CATERING_SUCCESSFUL = 'CATERING_SUCCESSFUL',
  INSERT_ERROR = 'INSERT_ERROR',
  INSERT_REQUESTED = 'INSERT_REQUESTED',
  INSERT_SUCCESSFUL = 'INSERT_SUCCESSFUL',
  KOUNT_DENIAL = 'KOUNT_DENIAL',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PAYMENT_REQUESTED = 'PAYMENT_REQUESTED',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PAYMENT_SUCCESSFUL = 'PAYMENT_SUCCESSFUL',
  PRICE_ERROR = 'PRICE_ERROR',
  PRICE_REQUESTED = 'PRICE_REQUESTED',
  PRICE_SUCCESSFUL = 'PRICE_SUCCESSFUL',
  REFUND_ERROR = 'REFUND_ERROR',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
  REFUND_SUCCESSFUL = 'REFUND_SUCCESSFUL',
  UPDATE_ERROR = 'UPDATE_ERROR',
  UPDATE_REQUESTED = 'UPDATE_REQUESTED',
  UPDATE_SUCCESSFUL = 'UPDATE_SUCCESSFUL',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

export interface IRecommendationItem {
  readonly __typename?: 'RecommendationItem';
  /** The item id of recommendation item */
  readonly id: Scalars['String'];
}

export interface IRecommendationItemResult {
  readonly __typename?: 'RecommendationItemResult';
  readonly recommendationToken?: Maybe<Scalars['String']>;
  readonly recommender?: Maybe<Scalars['String']>;
  readonly results?: Maybe<ReadonlyArray<Maybe<IRecommendationItem>>>;
}

export enum RecommendationType {
  CART = 'CART',
  MENU = 'MENU'
}

export interface IRefund {
  readonly __typename?: 'Refund';
  /** Reason picked from a predefined dropdown list */
  readonly primaryReason: RefundReason;
  /** Items that were refunded. Undefined if order was fully refunded. */
  readonly refundedItems?: Maybe<ReadonlyArray<Maybe<IRefundedItem>>>;
  /** Optional reason either added by a support agent or an user via the support form */
  readonly secondaryReason?: Maybe<Scalars['String']>;
  readonly subtotal: Scalars['String'];
  readonly tax: Scalars['String'];
  /** Date time when refund was issued */
  readonly transactionDateTime: Scalars['String'];
}

export interface IRefundEligibilityResponse {
  readonly __typename?: 'RefundEligibilityResponse';
  readonly eligible: Scalars['Boolean'];
  readonly ineligibilityReason?: Maybe<RefundIneligibilityReason>;
}

export enum RefundIneligibilityReason {
  ALREADY_REFUNDED = 'ALREADY_REFUNDED',
  DISABLED = 'DISABLED',
  INVALID_ORDER_STATUS = 'INVALID_ORDER_STATUS',
  INVALID_PAYMENT_TYPE = 'INVALID_PAYMENT_TYPE',
  INVALID_USER_ID = 'INVALID_USER_ID',
  ORDER_BEING_DELIVERED = 'ORDER_BEING_DELIVERED',
  ORDER_NOT_FOUND = 'ORDER_NOT_FOUND',
  OVER_ALLOWED_REFUND_AMOUNT = 'OVER_ALLOWED_REFUND_AMOUNT',
  REFUNDED_MAX_TIMES = 'REFUNDED_MAX_TIMES'
}

export enum RefundReason {
  CATERING_ORDER_DECLINED = 'CATERING_ORDER_DECLINED',
  CATERING_ORDER_ERROR = 'CATERING_ORDER_ERROR',
  CATERING_ORDER_TIME_OUT = 'CATERING_ORDER_TIME_OUT',
  CUSTOMER_OVERCHARGED = 'CUSTOMER_OVERCHARGED',
  CUSTOMER_REQUESTED_CANCEL_ORDER = 'CUSTOMER_REQUESTED_CANCEL_ORDER',
  FOOD_QUALITY_ISSUE = 'FOOD_QUALITY_ISSUE',
  INCORRECT_CUSTOMIZATION = 'INCORRECT_CUSTOMIZATION',
  ITEMS_OUT_OF_STOCK = 'ITEMS_OUT_OF_STOCK',
  MISSING_OR_INCORRECT_ITEM = 'MISSING_OR_INCORRECT_ITEM',
  MOBILE_ORDERING_TECHNICAL_ISSUE = 'MOBILE_ORDERING_TECHNICAL_ISSUE',
  ORDER_ARRIVED_LATE = 'ORDER_ARRIVED_LATE',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_COMMIT_ERROR = 'ORDER_COMMIT_ERROR',
  ORDER_NEVER_ARRIVED = 'ORDER_NEVER_ARRIVED',
  ORDER_WAS_DAMAGED = 'ORDER_WAS_DAMAGED',
  OTHER_ADD_COMMENT = 'OTHER_ADD_COMMENT',
  RECEIVED_INCORRECT_ORDER = 'RECEIVED_INCORRECT_ORDER',
  RESTAURANT_CLOSED = 'RESTAURANT_CLOSED',
  RESTAURANT_COULDNT_FIND_ORDER = 'RESTAURANT_COULDNT_FIND_ORDER'
}

export interface IRefundRequestResponse {
  readonly __typename?: 'RefundRequestResponse';
  /** Requested refund amount in cents */
  readonly refundRequestAmountCents: Scalars['Int'];
  /** Date time when refund was requested */
  readonly requestDateTime?: Maybe<Scalars['String']>;
}

export interface IRefundedItem {
  readonly __typename?: 'RefundedItem';
  /** Name of item refunded */
  readonly name?: Maybe<Scalars['String']>;
  /** Plu of item refunded */
  readonly plu?: Maybe<Scalars['String']>;
  /** Amount refunded in dollars for item */
  readonly refundAmount?: Maybe<Scalars['String']>;
  /** Quantity of item refunded */
  readonly refundQuantity?: Maybe<Scalars['String']>;
  /** SanityId of item refunded */
  readonly sanityId?: Maybe<Scalars['String']>;
  /** Type of item refunded */
  readonly type?: Maybe<CartEntryType>;
}

/** A Prepaid Reload response (payment method) */
export interface IReload {
  readonly __typename?: 'Reload';
  /** dollar amount gift card begins with */
  readonly beginBalance: Scalars['Int'];
  readonly currencyCode: Scalars['String'];
  /** current gift card balance in dollars */
  readonly currentBalance: Scalars['Int'];
  /** First Data account id of gift card */
  readonly fdAccountId: Scalars['String'];
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  readonly transactionId: Scalars['String'];
}

export interface IResendOtpInput {
  /**
   * User email. Only one of email or phone number should be provided
   * Example foobar@example.com
   */
  readonly email?: InputMaybe<Scalars['String']>;
  /**
   * User phone number. Only one of email or phone number should be provided
   * Example 4258675309
   */
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  /** Requestor's platform */
  readonly platform: Platform;
}

export interface IRestaurant {
  readonly __typename?: 'Restaurant';
  /**
   * Boolean value for whether or not the restaurant is available
   * This is determined by the restaurant's heartbeat data stored in sanity
   */
  readonly available: Scalars['Boolean'];
  /** Curbside operating hours */
  readonly curbsideHours?: Maybe<IOperatingHours>;
  /** Day parts from sanity */
  readonly dayParts?: Maybe<ReadonlyArray<Maybe<IDayPart>>>;
  /** Delivery operating hours */
  readonly deliveryHours?: Maybe<IOperatingHours>;
  /** Dining room operating hours */
  readonly diningRoomHours?: Maybe<IOperatingHours>;
  /** Drive through operating hours */
  readonly driveThruHours?: Maybe<IOperatingHours>;
  /**
   * DEPRECATED
   * Last record heartbeat timestamp on this restaurant
   * @deprecated Only for internal use
   */
  readonly lastHeartbeatTimestamp?: Maybe<Scalars['String']>;
  /** Pos Vendor associated with restaurant */
  readonly posVendor?: Maybe<Scalars['String']>;
  /**
   * The MDM number identifier. This is the `number` property on the sanity store obj
   * this is NOT the `_id` property
   */
  readonly storeId?: Maybe<Scalars['String']>;
  /** Restaurant Vat Number for BK UK */
  readonly vatNumber?: Maybe<Scalars['String']>;
}

export interface IRestaurantEdge extends IEdge {
  readonly __typename?: 'RestaurantEdge';
  readonly cursor: Scalars['String'];
  readonly node: IRestaurantNode;
}

/** Extended restaurant data containing all fields from Sanity + Dynamo */
export interface IRestaurantNode extends INode {
  readonly __typename?: 'RestaurantNode';
  /** While pagination spec requires an id, Sanity and Frontend use _id */
  readonly _id?: Maybe<Scalars['String']>;
  readonly chaseMerchantId?: Maybe<Scalars['String']>;
  readonly curbsideHours?: Maybe<IOperatingHours>;
  readonly deliveryHours?: Maybe<IOperatingHours>;
  readonly diningRoomHours?: Maybe<IOperatingHours>;
  readonly distanceInMiles?: Maybe<Scalars['Int']>;
  readonly drinkStationType?: Maybe<Scalars['String']>;
  readonly driveThruHours?: Maybe<IOperatingHours>;
  readonly driveThruLaneType?: Maybe<Scalars['String']>;
  readonly email?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly environment?: Maybe<RestaurantStatus>;
  readonly franchiseGroupId?: Maybe<Scalars['Int']>;
  readonly franchiseGroupName?: Maybe<Scalars['String']>;
  readonly frontCounterClosed?: Maybe<Scalars['Boolean']>;
  readonly hasBreakfast?: Maybe<Scalars['Boolean']>;
  readonly hasBurgersForBreakfast?: Maybe<Scalars['Boolean']>;
  readonly hasCatering?: Maybe<Scalars['Boolean']>;
  readonly hasCurbside?: Maybe<Scalars['Boolean']>;
  readonly hasDelivery?: Maybe<Scalars['Boolean']>;
  readonly hasDineIn?: Maybe<Scalars['Boolean']>;
  readonly hasDriveThru?: Maybe<Scalars['Boolean']>;
  readonly hasLateNightMenu?: Maybe<Scalars['Boolean']>;
  readonly hasLoyalty?: Maybe<Scalars['Boolean']>;
  readonly hasMobileOrdering?: Maybe<Scalars['Boolean']>;
  readonly hasParking?: Maybe<Scalars['Boolean']>;
  readonly hasPlayground?: Maybe<Scalars['Boolean']>;
  readonly hasTableService?: Maybe<Scalars['Boolean']>;
  readonly hasTakeOut?: Maybe<Scalars['Boolean']>;
  readonly hasWifi?: Maybe<Scalars['Boolean']>;
  /** Arbitrary unique identifier. */
  readonly id?: Maybe<Scalars['ID']>;
  /**
   * Boolean value for whether or not the restaurant is available
   * This is determined by the restaurant's heartbeat data stored in sanity
   */
  readonly isAvailable: Scalars['Boolean'];
  readonly isDarkKitchen?: Maybe<Scalars['Boolean']>;
  readonly isFavorite: Scalars['Boolean'];
  readonly isHalal?: Maybe<Scalars['Boolean']>;
  readonly isRecent: Scalars['Boolean'];
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly mobileOrderingStatus?: Maybe<OrderingStatus>;
  readonly name?: Maybe<Scalars['String']>;
  readonly number?: Maybe<Scalars['String']>;
  readonly parkingType?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly physicalAddress?: Maybe<IPhysicalAddress>;
  readonly playgroundType?: Maybe<Scalars['String']>;
  readonly pos?: Maybe<IRestaurantPos>;
  readonly posRestaurantId?: Maybe<Scalars['String']>;
  /** Pos Vendor associated with restaurant */
  readonly posVendor?: Maybe<Scalars['String']>;
  readonly restaurantImage?: Maybe<ISanityImage>;
  readonly restaurantPosData?: Maybe<IRestaurantPosData>;
  readonly status?: Maybe<Scalars['String']>;
  /**
   * The MDM number identifier. This is the `number` property on the sanity store obj
   * this is NOT the `_id` property
   */
  readonly storeId?: Maybe<Scalars['String']>;
  readonly vatNumber?: Maybe<Scalars['String']>;
}

export interface IRestaurantPos {
  readonly __typename?: 'RestaurantPos';
  readonly vendor?: Maybe<Scalars['String']>;
}

export interface IRestaurantPosData {
  readonly __typename?: 'RestaurantPosData';
  readonly _id?: Maybe<Scalars['String']>;
}

export enum RestaurantStatus {
  DEV = 'DEV',
  PROD = 'PROD'
}

export interface IRestaurantsConnection extends IConnection {
  readonly __typename?: 'RestaurantsConnection';
  readonly edges: ReadonlyArray<IRestaurantEdge>;
  readonly nodes: ReadonlyArray<IRestaurantNode>;
  readonly pageInfo: IPageInfo;
  readonly totalCount?: Maybe<Scalars['Int']>;
}

export interface IRestaurantsInput {
  /**
   * An opaque cursor for pagination. Return results after provided cursor.
   * Used in combination with first field.
   */
  readonly after?: InputMaybe<Scalars['String']>;
  /**
   * An opaque cursor for pagination. Return results before provided cursor.
   * Used in combination with last field.
   */
  readonly before?: InputMaybe<Scalars['String']>;
  /** A coordinates object that sorts results based on location provided. */
  readonly coordinates?: InputMaybe<ICoordinates>;
  /**
   * Filter to a subset of stores
   * Defaults to NEARBY
   */
  readonly filter?: InputMaybe<FilterRestaurantType>;
  /**
   * Return first provided number of edges for pagination query.
   * Used in combination with after field.
   */
  readonly first?: InputMaybe<Scalars['Int']>;
  /** A list of store IDs to filter to */
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * Return last provided number of edges for pagination query.
   * Used in combination with before field.
   */
  readonly last?: InputMaybe<Scalars['Int']>;
  /**
   * A flag to enable strict radius checking. When enabled, stores will be filtered
   * based on a circle radius. Any stores outside the radius are not included.
   */
  readonly radiusStrictMode?: InputMaybe<Scalars['Boolean']>;
  /**
   * A list of service modes to search for.
   * Filters list to subset of stores that have one of the service modes available.
   */
  readonly serviceModes?: InputMaybe<ReadonlyArray<ServiceMode>>;
  /**
   * Restaurant operational status.
   * Filters list to subset of stores that have the provided status.
   */
  readonly status?: InputMaybe<OperationalStatus>;
}

/** Resume 3DS sale transaction input */
export interface IResumeThreeDSaleTransaction {
  /** saleId of the transaction */
  readonly saleId: Scalars['String'];
  /** threeDSOptions to resume 3ds flow transaction */
  readonly threeDSOptions: IThreeDsOptions;
}

/** WARNING: Likely to be deprecated in favor of "order" */
export interface ISale {
  readonly __typename?: 'Sale';
  /**
   * First Data sale id. This will be used for any further actions on the sale
   * (eg to void the sale)
   */
  readonly fdSaleId: Scalars['String'];
  /** Id for generated order */
  readonly orderId: Scalars['String'];
  readonly status?: Maybe<Scalars['String']>;
}

export interface ISanityImage {
  readonly __typename?: 'SanityImage';
  readonly asset?: Maybe<ISanityImageAsset>;
  readonly crop?: Maybe<ISanityImageCrop>;
  readonly hotspot?: Maybe<ISanityImageHotspot>;
}

export interface ISanityImageAsset {
  readonly __typename?: 'SanityImageAsset';
  readonly _id?: Maybe<Scalars['String']>;
  readonly metadata?: Maybe<ISanityImageMetaData>;
}

export interface ISanityImageCrop {
  readonly __typename?: 'SanityImageCrop';
  readonly bottom?: Maybe<Scalars['Float']>;
  readonly left?: Maybe<Scalars['Float']>;
  readonly right?: Maybe<Scalars['Float']>;
  readonly top?: Maybe<Scalars['Float']>;
}

export interface ISanityImageHotspot {
  readonly __typename?: 'SanityImageHotspot';
  readonly height?: Maybe<Scalars['Float']>;
  readonly width?: Maybe<Scalars['Float']>;
  readonly x?: Maybe<Scalars['Float']>;
  readonly y?: Maybe<Scalars['Float']>;
}

export interface ISanityImageMetaData {
  readonly __typename?: 'SanityImageMetaData';
  readonly lqip?: Maybe<Scalars['String']>;
  readonly palette?: Maybe<ISanityImagePalette>;
}

export interface ISanityImagePalette {
  readonly __typename?: 'SanityImagePalette';
  readonly dominant?: Maybe<ISanityImagePaletteSwatch>;
}

export interface ISanityImagePaletteSwatch {
  readonly __typename?: 'SanityImagePaletteSwatch';
  readonly background?: Maybe<Scalars['String']>;
  readonly foreground?: Maybe<Scalars['String']>;
}

export enum ServiceMode {
  CATERING_DELIVERY = 'CATERING_DELIVERY',
  CATERING_PICKUP = 'CATERING_PICKUP',
  CURBSIDE = 'CURBSIDE',
  DELIVERY = 'DELIVERY',
  DRIVE_THRU = 'DRIVE_THRU',
  EAT_IN = 'EAT_IN',
  TABLE_SERVICE = 'TABLE_SERVICE',
  TAKEOUT = 'TAKEOUT'
}

export interface ISignInUserInput {
  readonly email: Scalars['String'];
  readonly platform: Platform;
  readonly stage: Stage;
}

export interface ISignUpUserInput {
  readonly country: IsoCountryCode;
  readonly dob?: InputMaybe<Scalars['String']>;
  readonly favoriteStores?: InputMaybe<ReadonlyArray<IFavoriteStoreSignUpInput>>;
  readonly gender?: InputMaybe<Gender>;
  readonly name: Scalars['String'];
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  readonly platform: Platform;
  readonly stage: Stage;
  readonly userName: Scalars['String'];
  readonly wantsPromotionalEmails: Scalars['Boolean'];
  readonly zipcode?: InputMaybe<Scalars['String']>;
}

export interface ISizeBasedPlu {
  readonly __typename?: 'SizeBasedPlu';
  readonly comboPlu?: Maybe<Scalars['String']>;
  readonly comboSize?: Maybe<Scalars['String']>;
}

export interface ISizeBasedPluInput {
  readonly comboPlu?: InputMaybe<Scalars['String']>;
  readonly comboSize?: InputMaybe<Scalars['String']>;
}

export enum Stage {
  ALPHA = 'alpha',
  BETA = 'beta',
  DEV = 'dev',
  LOCALDEV = 'localdev',
  PROD = 'prod',
  QA = 'qa',
  SANDBOX = 'sandbox',
  STAGING = 'staging',
  TEST = 'test'
}

export interface IStoreAddress {
  readonly __typename?: 'StoreAddress';
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly phoneNumber: Scalars['String'];
  readonly state: Scalars['String'];
  readonly zip: Scalars['String'];
}

export interface IStoreAddressInput {
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: InputMaybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly phoneNumber: Scalars['String'];
  readonly state: Scalars['String'];
  readonly zip: Scalars['String'];
}

export interface IStoreDetails {
  readonly __typename?: 'StoreDetails';
  readonly deliveryHours?: Maybe<IStoreHours>;
  readonly diningRoomHours?: Maybe<IStoreHours>;
  readonly driveThruHours?: Maybe<IStoreHours>;
  readonly franchiseGroupId?: Maybe<Scalars['Int']>;
  readonly franchiseGroupName?: Maybe<Scalars['String']>;
  readonly hasCatering?: Maybe<Scalars['Boolean']>;
  readonly hasDelivery?: Maybe<Scalars['Boolean']>;
  readonly hasDriveThru?: Maybe<Scalars['Boolean']>;
  readonly hasMobileOrdering?: Maybe<Scalars['Boolean']>;
  readonly hasTableService?: Maybe<Scalars['Boolean']>;
  /** Last date time when the store made an order */
  readonly lastActiveDateTime?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly mobileOrderingStatus?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly posVendor?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly storeNumber?: Maybe<Scalars['String']>;
}

export interface IStoreHours {
  readonly __typename?: 'StoreHours';
  readonly friday?: Maybe<IDay>;
  readonly monday?: Maybe<IDay>;
  readonly saturday?: Maybe<IDay>;
  readonly sunday?: Maybe<IDay>;
  readonly thursday?: Maybe<IDay>;
  readonly tuesday?: Maybe<IDay>;
  readonly wednesday?: Maybe<IDay>;
}

export interface ISupportCase {
  readonly __typename?: 'SupportCase';
  /** Identifier for the case. Useful for the user to have */
  readonly caseId?: Maybe<Scalars['String']>;
  /** The creation date of the ticket  */
  readonly created?: Maybe<Scalars['String']>;
}

export interface ISupportCaseInput {
  /** Description of the issue the user is having */
  readonly comments: Scalars['String'];
  /** User's email */
  readonly email: Scalars['String'];
  /** Category of the issue */
  readonly issueCategory?: InputMaybe<Scalars['String']>;
  /** Id corresponding to the category of the issue. These are set in Sanity */
  readonly issueId: Scalars['String'];
  /** The status of the issue, i.e. 'OPEN' or 'CLOSED' */
  readonly issueStatus?: InputMaybe<ITicketStatus>;
  /** Name of subcategory of the issue.  These are set in Sanity */
  readonly issueSubCategory?: InputMaybe<Scalars['String']>;
  /** The local time the order associated with the issue was placed */
  readonly localStoreOrderTime?: InputMaybe<Scalars['String']>;
  /** User's name */
  readonly name: Scalars['String'];
  /** The time and date the order associated with the issue was placed */
  readonly orderDateTime?: InputMaybe<Scalars['String']>;
  /** Unique order identifier in RBI */
  readonly rbiOrderId?: InputMaybe<Scalars['String']>;
  /** Service mode of the order associated with the issue */
  readonly serviceMode?: InputMaybe<Scalars['String']>;
  /** Address of the store associated with the issue */
  readonly storeAddress?: InputMaybe<Scalars['String']>;
  /** Store number from MDS */
  readonly storeId?: InputMaybe<Scalars['String']>;
  /** Region user signed up in (account region) */
  readonly userAccountRegion?: InputMaybe<Scalars['String']>;
  /** User's region */
  readonly userRegion?: InputMaybe<Scalars['String']>;
}

export interface ISwapInput {
  readonly cartId: Scalars['String'];
  readonly from: Scalars['String'];
  readonly swapType: Scalars['String'];
  readonly to: Scalars['String'];
}

export interface IThreeDsOptions {
  /** challenge response obtained in challengeCallbackUrl to resume challenge flow */
  readonly challengeResponse?: InputMaybe<Scalars['String']>;
  /** transactionId to resume method or challenge flow */
  readonly transactionId: Scalars['String'];
}

export interface ITransactionListResponse {
  readonly __typename?: 'TransactionListResponse';
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  readonly transactions?: Maybe<ReadonlyArray<Maybe<IPrepaidTransaction>>>;
}

export interface IUnavailableCartEntry {
  readonly __typename?: 'UnavailableCartEntry';
  readonly lineId?: Maybe<Scalars['String']>;
  readonly sanityId: Scalars['String'];
}

export interface IUpdateOrderInput {
  /** number of seconds from now to inject order */
  readonly fireOrderIn: Scalars['Int'];
  readonly rbiOrderId: Scalars['ID'];
}

export interface IUpdateUserDetailsInput {
  /** If true, the user has opted out of personalized ad tracking. */
  readonly adsPersonalizationOptOut?: InputMaybe<Scalars['Boolean']>;
  readonly autoReloadEnabled?: InputMaybe<Scalars['Boolean']>;
  readonly autoReloadThreshold?: InputMaybe<Scalars['Int']>;
  readonly communicationPreferences?: InputMaybe<ReadonlyArray<InputMaybe<ICommunicationPreferenceInput>>>;
  readonly defaultAccountIdentifier?: InputMaybe<Scalars['String']>;
  /** @deprecated(reason: "Use `defaultAccountIdentifier`.") */
  readonly defaultFdAccountId?: InputMaybe<Scalars['String']>;
  readonly defaultPaymentAccountId?: InputMaybe<Scalars['String']>;
  readonly defaultReloadAmt?: InputMaybe<Scalars['Int']>;
  readonly defaultScanAndPayAccountIdentifier?: InputMaybe<Scalars['String']>;
  readonly dob?: InputMaybe<Scalars['String']>;
  readonly dobDeleted?: InputMaybe<Scalars['Boolean']>;
  readonly favoriteOffers?: InputMaybe<ReadonlyArray<InputMaybe<IFavoriteOfferInput>>>;
  readonly favoriteStores?: InputMaybe<ReadonlyArray<InputMaybe<IFavoriteStoreInput>>>;
  readonly gender?: InputMaybe<Gender>;
  readonly isoCountryCode?: InputMaybe<IsoCountryCode>;
  readonly loyaltyTier?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  readonly promotionalEmails?: InputMaybe<Scalars['Boolean']>;
  readonly rutrFailedSkillsTestTimestamp?: InputMaybe<Scalars['String']>;
  readonly rutrPassedSkillsTestTimestamp?: InputMaybe<Scalars['String']>;
  readonly showThLoyaltyOnboarding?: InputMaybe<Scalars['Boolean']>;
  readonly zipcode?: InputMaybe<Scalars['String']>;
}

export interface IUser {
  readonly __typename?: 'User';
  /** Cognito user id */
  readonly cognitoId: Scalars['ID'];
  readonly createdAt: Scalars['String'];
  readonly details: IUserDetails;
  /** loyaltyId used for loyalty API lookup */
  readonly loyaltyId?: Maybe<Scalars['String']>;
  /** TH Legacy Cogntio User ID */
  readonly thLegacyCognitoId?: Maybe<Scalars['String']>;
  readonly uniquePurchasedItems?: Maybe<ReadonlyArray<Maybe<ICartEntries>>>;
  readonly updatedAt: Scalars['String'];
}

export enum UserCardCardFormat {
  DIGITAL = 'digital',
  PHYSICAL = 'physical'
}

export enum UserCardCardStatus {
  ACTIVE = 'Active',
  INACTIVE = 'InActive'
}

export enum UserCardCardType {
  ACCUMULATEREDEMPTIONS = 'AccumulateRedemptions'
}

export interface IUserDetails {
  readonly __typename?: 'UserDetails';
  /** If true, the user has opted out of personalized ad tracking. */
  readonly adsPersonalizationOptOut?: Maybe<Scalars['Boolean']>;
  /** Giftcard can be auto reloaded */
  readonly autoReloadEnabled?: Maybe<Scalars['Boolean']>;
  /** Amount in cents that balance must reach for auto reload */
  readonly autoReloadThreshold?: Maybe<Scalars['Int']>;
  /** Array of Communication Preferences */
  readonly communicationPreferences?: Maybe<ReadonlyArray<Maybe<ICommunicationPreference>>>;
  /** Account (Adyen or First-Data) ID of auto reload default payment method */
  readonly defaultAccountIdentifier?: Maybe<Scalars['String']>;
  /**
   * First Data ID of auto reload default payment method
   * @deprecated Use `defaultAccountIdentifier`.
   */
  readonly defaultFdAccountId?: Maybe<Scalars['String']>;
  /** Adyen or First Data ID of default payment method */
  readonly defaultPaymentAccountId?: Maybe<Scalars['String']>;
  /** Reload amount to default to for user's gift cards */
  readonly defaultReloadAmt?: Maybe<Scalars['Int']>;
  /** Default Account Id for Scan & Pay */
  readonly defaultScanAndPayAccountIdentifier?: Maybe<Scalars['String']>;
  /**
   * User Adresses and phone number combinations to be used to alllow users
   * to select from multiple saced addresses
   */
  readonly deliveryAddresses?: Maybe<ReadonlyArray<Maybe<IDeliveryAddress>>>;
  /** Date of birth (format TBD) */
  readonly dob?: Maybe<Scalars['String']>;
  readonly dobDeleted?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  /** Whether the user has verified the email */
  readonly emailVerified?: Maybe<Scalars['Boolean']>;
  /** User's saved list of favorite offers */
  readonly favoriteOffers?: Maybe<ReadonlyArray<Maybe<IFavoriteOffer>>>;
  /** User's saved list of favorite stores */
  readonly favoriteStores?: Maybe<ReadonlyArray<Maybe<IFavoriteStore>>>;
  readonly gender?: Maybe<Gender>;
  /** User's ISO Country Code (e.g. USA, CAN) */
  readonly isoCountryCode?: Maybe<IsoCountryCode>;
  /** User's selected loyalty tier */
  readonly loyaltyTier?: Maybe<Scalars['String']>;
  /** User's name */
  readonly name?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  /** Whether the user has verified the phone number */
  readonly phoneVerified?: Maybe<Scalars['Boolean']>;
  /** Whether the user has opted in to promotional emails */
  readonly promotionalEmails?: Maybe<Scalars['Boolean']>;
  /** Last time the user failed the skills tests of RUTR */
  readonly rutrFailedSkillsTestTimestamp?: Maybe<Scalars['String']>;
  /** Last time the user passed the skills tests of RUTR */
  readonly rutrPassedSkillsTestTimestamp?: Maybe<Scalars['String']>;
  /** Whether the user should be shown the onboarding flow */
  readonly showThLoyaltyOnboarding?: Maybe<Scalars['Boolean']>;
  readonly zipcode?: Maybe<Scalars['String']>;
}

export interface IUserGeo {
  readonly __typename?: 'UserGeo';
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
}

export interface IUserReportsMissingOrderInput {
  /** Id corresponding to the category of the issue. These are set in Sanity */
  readonly issueId?: InputMaybe<Scalars['String']>;
  /** Name of subcategory of the issue.  These are set in Sanity */
  readonly issueSubCategory?: InputMaybe<Scalars['String']>;
  /** List of reported missing items. Undefined if entire order is missing */
  readonly missingItems?: InputMaybe<ReadonlyArray<InputMaybe<IMissingItem>>>;
  /** Order ID that the user is reporting */
  readonly rbiOrderId: Scalars['String'];
  /** Optional user comment as part of the report */
  readonly userComment?: InputMaybe<Scalars['String']>;
}

export interface IUserRequestsRefundInput {
  /** Id corresponding to the category of the issue. These are set in Sanity */
  readonly issueId?: InputMaybe<Scalars['String']>;
  /** Name of subcategory of the issue.  These are set in Sanity */
  readonly issueSubCategory?: InputMaybe<Scalars['String']>;
  /** List of reported missing items. Undefined if entire order is missing */
  readonly missingItems?: InputMaybe<ReadonlyArray<InputMaybe<IMissingItem>>>;
  /** Order ID that the user is reporting */
  readonly rbiOrderId: Scalars['String'];
  /** Optional user comment as part of the report */
  readonly userComment?: InputMaybe<Scalars['String']>;
}

export interface IValidateCommitOrderInput {
  /** Delivery information */
  readonly delivery?: InputMaybe<ICommitDeliveryInput>;
  /** Takes in a time in seconds to delay the order commit */
  readonly fireOrderIn?: InputMaybe<Scalars['Int']>;
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['String'];
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: InputMaybe<Scalars['String']>;
  /** Whether to skip cooling period or not */
  readonly skipCoolingPeriod?: InputMaybe<Scalars['Boolean']>;
}

export interface IVendorConfig {
  readonly __typename?: 'VendorConfig';
  readonly constantPlu?: Maybe<Scalars['String']>;
  readonly discountPlu?: Maybe<Scalars['String']>;
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>;
  readonly parentChildPlu?: Maybe<IParentChildPlu>;
  readonly parentSanityId?: Maybe<Scalars['String']>;
  readonly pluType: Scalars['String'];
  readonly pullUpLevels?: Maybe<Scalars['Int']>;
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>;
  readonly sizeBasedPlu?: Maybe<ISizeBasedPlu>;
}

export interface IVendorConfigInput {
  readonly constantPlu?: InputMaybe<Scalars['String']>;
  readonly discountPlu?: InputMaybe<Scalars['String']>;
  readonly multiConstantPlus?: InputMaybe<ReadonlyArray<InputMaybe<IQuantityPluInput>>>;
  readonly parentChildPlu?: InputMaybe<IParentChildPluInput>;
  readonly parentSanityId?: InputMaybe<Scalars['String']>;
  readonly pluType: Scalars['String'];
  readonly pullUpLevels?: InputMaybe<Scalars['Int']>;
  readonly quantityBasedPlu?: InputMaybe<ReadonlyArray<InputMaybe<IQuantityPluInput>>>;
  readonly sizeBasedPlu?: InputMaybe<ISizeBasedPluInput>;
}

export interface IVendorConfigs {
  readonly __typename?: 'VendorConfigs';
  readonly brink?: Maybe<IVendorConfig>;
  readonly brinkDelivery?: Maybe<IVendorConfig>;
  readonly carrols?: Maybe<IVendorConfig>;
  readonly carrolsDelivery?: Maybe<IVendorConfig>;
  readonly ncr?: Maybe<IVendorConfig>;
  readonly ncrDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly oheics?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly oheicsDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly partner?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly partnerDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly productNumber?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly productNumberDelivery?: Maybe<IVendorConfig>;
  readonly qdi?: Maybe<IVendorConfig>;
  readonly qdiDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly qst?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly qstDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly rpos?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly rposDelivery?: Maybe<IVendorConfig>;
  readonly sicom?: Maybe<IVendorConfig>;
  readonly sicomDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly simphony?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly simphonyDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly simplyDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly simplyDeliveryDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly tablet?: Maybe<IVendorConfig>;
  /** @deprecated POS no longer in use */
  readonly tabletDelivery?: Maybe<IVendorConfig>;
}

export interface IVendorConfigsInput {
  readonly brink?: InputMaybe<IVendorConfigInput>;
  readonly brinkDelivery?: InputMaybe<IVendorConfigInput>;
  readonly carrols?: InputMaybe<IVendorConfigInput>;
  readonly carrolsDelivery?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly hdx?: InputMaybe<IVendorConfigInput>;
  readonly ncr?: InputMaybe<IVendorConfigInput>;
  readonly ncrDelivery?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly oheics?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly oheicsDelivery?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly partner?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly partnerDelivery?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly productNumber?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly productNumberDelivery?: InputMaybe<IVendorConfigInput>;
  readonly qdi?: InputMaybe<IVendorConfigInput>;
  readonly qdiDelivery?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly qst?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly qstDelivery?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly rpos?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly rposDelivery?: InputMaybe<IVendorConfigInput>;
  readonly sicom?: InputMaybe<IVendorConfigInput>;
  readonly sicomDelivery?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly simphony?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly simphonyDelivery?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly simplyDelivery?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly simplyDeliveryDelivery?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly tablet?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly tabletDelivery?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly xenial?: InputMaybe<IVendorConfigInput>;
  /** @deprecated(reason:"POS no longer in use") */
  readonly xenialDelivery?: InputMaybe<IVendorConfigInput>;
}

export interface IWllSession {
  readonly __typename?: 'WllSession';
  /** Session id */
  readonly session: Scalars['String'];
  /** Web base url */
  readonly webUrl: Scalars['String'];
  /** Vendor base url */
  readonly wllUrl: Scalars['String'];
}

export interface IResendPhoneVerificationInput {
  /** user's current platform */
  readonly platform: Platform;
  /** The unique identifier provided when the OTP was created */
  readonly sessionId?: InputMaybe<Scalars['ID']>;
  /** user's current stage */
  readonly stage: Stage;
}

export interface IResendVerificationEmailInput {
  /** user's current platform */
  readonly platform: Platform;
  /** user's current stage */
  readonly stage: Stage;
}

export interface IValidateAuthJwtInput {
  readonly jwt: Scalars['String'];
}

export interface IVerifyPhoneNumberInput {
  /** The code associated with the user's current OTP, for validation */
  readonly code: Scalars['String'];
  /** user's current platform */
  readonly platform: Platform;
  /** The unique identifier provided when the OTP was created */
  readonly sessionId: Scalars['ID'];
  /** user's current stage */
  readonly stage: Stage;
}

export type ICartEntryFragment = { readonly __typename?: 'CartEntries', readonly lineId: string, readonly image?: string | null, readonly isDonation?: boolean | null, readonly isExtra?: boolean | null, readonly name?: string | null, readonly pickerSelections?: string | null, readonly price?: number | null, readonly quantity: number, readonly sanityId: string, readonly type: CartEntryType, readonly url?: string | null, readonly redeemable?: boolean | null, readonly _id: string, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IPlusFragment
  ) | null };

export type ICartEntryWithChildrenFragment = (
  { readonly __typename?: 'CartEntries', readonly children?: ReadonlyArray<(
    { readonly __typename?: 'CartEntries', readonly children?: ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly children?: ReadonlyArray<(
        { readonly __typename?: 'CartEntries', readonly children?: ReadonlyArray<(
          { readonly __typename?: 'CartEntries', readonly children?: ReadonlyArray<(
            { readonly __typename?: 'CartEntries' }
            & ICartEntryFragment
          ) | null> | null }
          & ICartEntryFragment
        ) | null> | null }
        & ICartEntryFragment
      ) | null> | null }
      & ICartEntryFragment
    ) | null> | null }
    & ICartEntryFragment
  ) | null> | null }
  & ICartEntryFragment
);

export type IOrderFragment = { readonly __typename?: 'Order', readonly createdAt: string, readonly posOrderId?: string | null, readonly rbiOrderId: string, readonly status: RbiOrderStatus, readonly fireOrderIn?: number | null, readonly orderNumberFormatted?: string | null, readonly _id: string, readonly cart: { readonly __typename?: 'Cart', readonly customerName: string, readonly posVendor: PosVendor, readonly serviceMode: ServiceMode, readonly subTotalCents?: number | null, readonly taxCents?: number | null, readonly ticketNumber?: string | null, readonly totalCents?: number | null, readonly wasLoyaltyEarned?: boolean | null, readonly vatNumber?: string | null, readonly cartEntries?: ReadonlyArray<(
      { readonly __typename?: 'CartEntries' }
      & ICartEntryWithChildrenFragment
    )> | null, readonly discounts?: ReadonlyArray<{ readonly __typename?: 'Discount', readonly name?: DiscountTypes | null, readonly value?: number | null } | null> | null, readonly donations?: ReadonlyArray<{ readonly __typename?: 'Donation', readonly id?: string | null, readonly name?: string | null, readonly totalCents?: number | null } | null> | null, readonly fees?: ReadonlyArray<{ readonly __typename?: 'Fees', readonly name?: string | null, readonly priceCents?: number | null, readonly quantity?: number | null, readonly totalCents?: number | null } | null> | null, readonly offersFeedback?: ReadonlyArray<{ readonly __typename?: 'CouponUserOffersFeedbackEntry', readonly couponId: string, readonly cartEntry?: { readonly __typename?: 'CartEntries', readonly lineId: string } | null, readonly redemptionEligibility: { readonly __typename?: 'CouponRedemptionEligibility', readonly isRedeemable: boolean, readonly isValid: boolean, readonly evaluationFeedback: ReadonlyArray<{ readonly __typename?: 'CouponEvaluationFeedback', readonly code: string, readonly condition: boolean, readonly message: string, readonly redeemableForSeconds?: number | null, readonly redeemableInSeconds?: number | null, readonly ruleSetType: string } | null> } } | null> | null, readonly payment?: { readonly __typename?: 'Payment', readonly cardType?: string | null, readonly ccLast4?: string | null, readonly panToken?: string | null, readonly paymentType?: CartPaymentType | null } | null, readonly rewardsApplied?: ReadonlyArray<{ readonly __typename?: 'CartAppliedReward', readonly cartId: string, readonly rewardId: string, readonly timesApplied: number } | null> | null, readonly storeAddress: { readonly __typename?: 'StoreAddress', readonly addressLine1: string, readonly addressLine2?: string | null, readonly city: string, readonly state: string, readonly zip: string }, readonly storeDetails?: { readonly __typename?: 'StoreDetails', readonly latitude?: number | null, readonly longitude?: number | null, readonly storeNumber?: string | null } | null, readonly unavailableCartEntries?: ReadonlyArray<{ readonly __typename?: 'UnavailableCartEntry', readonly lineId?: string | null, readonly sanityId: string } | null> | null }, readonly delivery?: { readonly __typename?: 'Delivery', readonly feeCents: number, readonly feeDiscountCents?: number | null, readonly instructions?: string | null, readonly status: DeliveryStatus, readonly shareUuid?: string | null, readonly tipCents?: number | null, readonly serviceFeeCents?: number | null, readonly smallCartFeeCents?: number | null, readonly geographicalFeeCents?: number | null, readonly quotedFeeCents?: number | null, readonly baseDeliveryFeeCents?: number | null, readonly deliverySurchargeFeeCents?: number | null, readonly pickup: { readonly __typename?: 'DeliveryWaypoint', readonly latitude?: number | null, readonly longitude?: number | null }, readonly dropoff: { readonly __typename?: 'DeliveryWaypoint', readonly arrivalTime?: string | null, readonly beforeTime?: string | null, readonly addressLine1: string, readonly addressLine2?: string | null, readonly city: string, readonly state?: string | null, readonly zip?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly phoneNumber: string }, readonly driver?: { readonly __typename?: 'DeliveryDriver', readonly name?: string | null, readonly profileImageUrl?: string | null, readonly phoneNumber?: string | null } | null, readonly task?: { readonly __typename?: 'DeliveryTaskDetails', readonly uuid?: string | null } | null } | null, readonly loyaltyTransaction?: { readonly __typename?: 'LoyaltyTransaction', readonly id: string, readonly pointsEarned: number, readonly bonusPointsEarned: number, readonly pointsUsed: number, readonly pointsBalance: number, readonly rewardsUsed: number } | null };

export type IVcFragment = { readonly __typename?: 'VendorConfig', readonly pluType: string, readonly parentSanityId?: string | null, readonly constantPlu?: string | null, readonly quantityBasedPlu?: ReadonlyArray<{ readonly __typename?: 'QuantityPlu', readonly quantity?: number | null, readonly plu?: string | null, readonly qualifier?: string | null } | null> | null, readonly multiConstantPlus?: ReadonlyArray<{ readonly __typename?: 'QuantityPlu', readonly quantity?: number | null, readonly plu?: string | null, readonly qualifier?: string | null } | null> | null, readonly parentChildPlu?: { readonly __typename?: 'ParentChildPlu', readonly plu?: string | null, readonly childPlu?: string | null } | null, readonly sizeBasedPlu?: { readonly __typename?: 'SizeBasedPlu', readonly comboPlu?: string | null, readonly comboSize?: string | null } | null };

export type IPlusFragment = { readonly __typename?: 'VendorConfigs', readonly brink?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly brinkDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly carrols?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly carrolsDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly ncr?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly ncrDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly qdi?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly qdiDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly sicom?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly sicomDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null };

export type ICheckRefundEligibilityQueryVariables = Exact<{
  rbiOrderId: Scalars['ID'];
}>;


export type ICheckRefundEligibilityQuery = { readonly __typename?: 'Query', readonly checkRefundEligibility?: { readonly __typename?: 'RefundEligibilityResponse', readonly eligible: boolean, readonly ineligibilityReason?: RefundIneligibilityReason | null } | null };

export type ICreateSupportCaseMutationVariables = Exact<{
  caseInfo: ISupportCaseInput;
}>;


export type ICreateSupportCaseMutation = { readonly __typename?: 'Mutation', readonly createSupportCase?: { readonly __typename?: 'SupportCase', readonly caseId?: string | null } | null };

export type ICreateLoyaltyUserMutationVariables = Exact<{
  cognitoId: Scalars['String'];
}>;


export type ICreateLoyaltyUserMutation = { readonly __typename?: 'Mutation', readonly createLoyaltyUser: { readonly __typename?: 'User', readonly loyaltyId?: string | null } };

export type IPriceOrderMutationVariables = Exact<{
  input: IPriceOrderInput;
  delivery?: InputMaybe<IPriceDeliveryInput>;
}>;


export type IPriceOrderMutation = { readonly __typename?: 'Mutation', readonly priceOrder: { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly status: RbiOrderStatus } };

export type ICommitOrderMutationVariables = Exact<{
  input: ICommitOrderInput;
  delivery?: InputMaybe<ICommitDeliveryInput>;
  skipCoolingPeriod?: InputMaybe<Scalars['Boolean']>;
}>;


export type ICommitOrderMutation = { readonly __typename?: 'Mutation', readonly commitOrder: { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly status: RbiOrderStatus } };

export type IUpdateOrderMutationVariables = Exact<{
  input: IUpdateOrderInput;
}>;


export type IUpdateOrderMutation = { readonly __typename?: 'Mutation', readonly updateOrder: { readonly __typename?: 'Order', readonly rbiOrderId: string, readonly fireOrderIn?: number | null } };

export const VcFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}}]} as unknown as DocumentNode;
export const PlusFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}}]} as unknown as DocumentNode;
export const CartEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;
export const CartEntryWithChildrenFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;
export const OrderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"rbiOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"posOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"rbiOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fireOrderIn"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumberFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"cart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"cartEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"donations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"totalCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priceCents"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"totalCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offersFeedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"couponId"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionEligibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evaluationFeedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"redeemableForSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"redeemableInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"ruleSetType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRedeemable"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"ccLast4"}},{"kind":"Field","name":{"kind":"Name","value":"panToken"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posVendor"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsApplied"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartId"}},{"kind":"Field","name":{"kind":"Name","value":"rewardId"}},{"kind":"Field","name":{"kind":"Name","value":"timesApplied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceMode"}},{"kind":"Field","name":{"kind":"Name","value":"storeAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storeDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"storeNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subTotalCents"}},{"kind":"Field","name":{"kind":"Name","value":"taxCents"}},{"kind":"Field","name":{"kind":"Name","value":"ticketNumber"}},{"kind":"Field","name":{"kind":"Name","value":"totalCents"}},{"kind":"Field","name":{"kind":"Name","value":"unavailableCartEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wasLoyaltyEarned"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pickup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dropoff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"beforeTime"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"driver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feeCents"}},{"kind":"Field","name":{"kind":"Name","value":"feeDiscountCents"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shareUuid"}},{"kind":"Field","name":{"kind":"Name","value":"task"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tipCents"}},{"kind":"Field","name":{"kind":"Name","value":"serviceFeeCents"}},{"kind":"Field","name":{"kind":"Name","value":"smallCartFeeCents"}},{"kind":"Field","name":{"kind":"Name","value":"geographicalFeeCents"}},{"kind":"Field","name":{"kind":"Name","value":"quotedFeeCents"}},{"kind":"Field","name":{"kind":"Name","value":"baseDeliveryFeeCents"}},{"kind":"Field","name":{"kind":"Name","value":"deliverySurchargeFeeCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pointsEarned"}},{"kind":"Field","name":{"kind":"Name","value":"bonusPointsEarned"}},{"kind":"Field","name":{"kind":"Name","value":"pointsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"pointsBalance"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsUsed"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;
export const CheckRefundEligibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckRefundEligibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rbiOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"flag"},"value":{"kind":"StringValue","value":"enable-gateway-checkRefundEligibility","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkRefundEligibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"rbiOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rbiOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligible"}},{"kind":"Field","name":{"kind":"Name","value":"ineligibilityReason"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useCheckRefundEligibilityQuery__
 *
 * To run a query within a React component, call `useCheckRefundEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckRefundEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckRefundEligibilityQuery({
 *   variables: {
 *      rbiOrderId: // value for 'rbiOrderId'
 *   },
 * });
 */
export function useCheckRefundEligibilityQuery(baseOptions: Apollo.QueryHookOptions<ICheckRefundEligibilityQuery, ICheckRefundEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICheckRefundEligibilityQuery, ICheckRefundEligibilityQueryVariables>(CheckRefundEligibilityDocument, options);
      }
export function useCheckRefundEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICheckRefundEligibilityQuery, ICheckRefundEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICheckRefundEligibilityQuery, ICheckRefundEligibilityQueryVariables>(CheckRefundEligibilityDocument, options);
        }
export type CheckRefundEligibilityQueryHookResult = ReturnType<typeof useCheckRefundEligibilityQuery>;
export type CheckRefundEligibilityLazyQueryHookResult = ReturnType<typeof useCheckRefundEligibilityLazyQuery>;
export type CheckRefundEligibilityQueryResult = Apollo.QueryResult<ICheckRefundEligibilityQuery, ICheckRefundEligibilityQueryVariables>;
export const CreateSupportCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSupportCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caseInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportCaseInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"flag"},"value":{"kind":"StringValue","value":"enable-gateway-createSupportCase","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSupportCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"caseInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caseInfo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseId"}}]}}]}}]} as unknown as DocumentNode;
export type ICreateSupportCaseMutationFn = Apollo.MutationFunction<ICreateSupportCaseMutation, ICreateSupportCaseMutationVariables>;

/**
 * __useCreateSupportCaseMutation__
 *
 * To run a mutation, you first call `useCreateSupportCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupportCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupportCaseMutation, { data, loading, error }] = useCreateSupportCaseMutation({
 *   variables: {
 *      caseInfo: // value for 'caseInfo'
 *   },
 * });
 */
export function useCreateSupportCaseMutation(baseOptions?: Apollo.MutationHookOptions<ICreateSupportCaseMutation, ICreateSupportCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateSupportCaseMutation, ICreateSupportCaseMutationVariables>(CreateSupportCaseDocument, options);
      }
export type CreateSupportCaseMutationHookResult = ReturnType<typeof useCreateSupportCaseMutation>;
export type CreateSupportCaseMutationResult = Apollo.MutationResult<ICreateSupportCaseMutation>;
export type CreateSupportCaseMutationOptions = Apollo.BaseMutationOptions<ICreateSupportCaseMutation, ICreateSupportCaseMutationVariables>;
export const CreateLoyaltyUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLoyaltyUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cognitoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"flag"},"value":{"kind":"StringValue","value":"enable-gateway-createLoyaltyUser","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLoyaltyUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cognitoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cognitoId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyId"}}]}}]}}]} as unknown as DocumentNode;
export type ICreateLoyaltyUserMutationFn = Apollo.MutationFunction<ICreateLoyaltyUserMutation, ICreateLoyaltyUserMutationVariables>;

/**
 * __useCreateLoyaltyUserMutation__
 *
 * To run a mutation, you first call `useCreateLoyaltyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoyaltyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoyaltyUserMutation, { data, loading, error }] = useCreateLoyaltyUserMutation({
 *   variables: {
 *      cognitoId: // value for 'cognitoId'
 *   },
 * });
 */
export function useCreateLoyaltyUserMutation(baseOptions?: Apollo.MutationHookOptions<ICreateLoyaltyUserMutation, ICreateLoyaltyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateLoyaltyUserMutation, ICreateLoyaltyUserMutationVariables>(CreateLoyaltyUserDocument, options);
      }
export type CreateLoyaltyUserMutationHookResult = ReturnType<typeof useCreateLoyaltyUserMutation>;
export type CreateLoyaltyUserMutationResult = Apollo.MutationResult<ICreateLoyaltyUserMutation>;
export type CreateLoyaltyUserMutationOptions = Apollo.BaseMutationOptions<ICreateLoyaltyUserMutation, ICreateLoyaltyUserMutationVariables>;
export const PriceOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PriceOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceOrderInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delivery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceDeliveryInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"delivery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delivery"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rbiOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode;
export type IPriceOrderMutationFn = Apollo.MutationFunction<IPriceOrderMutation, IPriceOrderMutationVariables>;

/**
 * __usePriceOrderMutation__
 *
 * To run a mutation, you first call `usePriceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceOrderMutation, { data, loading, error }] = usePriceOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      delivery: // value for 'delivery'
 *   },
 * });
 */
export function usePriceOrderMutation(baseOptions?: Apollo.MutationHookOptions<IPriceOrderMutation, IPriceOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IPriceOrderMutation, IPriceOrderMutationVariables>(PriceOrderDocument, options);
      }
export type PriceOrderMutationHookResult = ReturnType<typeof usePriceOrderMutation>;
export type PriceOrderMutationResult = Apollo.MutationResult<IPriceOrderMutation>;
export type PriceOrderMutationOptions = Apollo.BaseMutationOptions<IPriceOrderMutation, IPriceOrderMutationVariables>;
export const CommitOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CommitOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommitOrderInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delivery"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CommitDeliveryInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipCoolingPeriod"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commitOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"delivery"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delivery"}}},{"kind":"Argument","name":{"kind":"Name","value":"skipCoolingPeriod"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipCoolingPeriod"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rbiOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode;
export type ICommitOrderMutationFn = Apollo.MutationFunction<ICommitOrderMutation, ICommitOrderMutationVariables>;

/**
 * __useCommitOrderMutation__
 *
 * To run a mutation, you first call `useCommitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitOrderMutation, { data, loading, error }] = useCommitOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *      delivery: // value for 'delivery'
 *      skipCoolingPeriod: // value for 'skipCoolingPeriod'
 *   },
 * });
 */
export function useCommitOrderMutation(baseOptions?: Apollo.MutationHookOptions<ICommitOrderMutation, ICommitOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICommitOrderMutation, ICommitOrderMutationVariables>(CommitOrderDocument, options);
      }
export type CommitOrderMutationHookResult = ReturnType<typeof useCommitOrderMutation>;
export type CommitOrderMutationResult = Apollo.MutationResult<ICommitOrderMutation>;
export type CommitOrderMutationOptions = Apollo.BaseMutationOptions<ICommitOrderMutation, ICommitOrderMutationVariables>;
export const UpdateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"flag"},"value":{"kind":"StringValue","value":"enable-react-native-fulfillment-service-update-order","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rbiOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"fireOrderIn"}}]}}]}}]} as unknown as DocumentNode;
export type IUpdateOrderMutationFn = Apollo.MutationFunction<IUpdateOrderMutation, IUpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateOrderMutation, IUpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateOrderMutation, IUpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<IUpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<IUpdateOrderMutation, IUpdateOrderMutationVariables>;
import { disableFragmentWarnings } from '@apollo/client';
disableFragmentWarnings();
